/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { ContractTermListDto, CustomerEditDto, CustomerLocationEditDto, ProductEditDto, ProviderEditDto, TicketNumberDto } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { FileDto, PartnerEditDto, UserListDto } from './shared-models';

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getActiveOrdersCount(partnerId: number | undefined): Observable<GetActiveOrdersCountOutput> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetActiveOrdersCount?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActiveOrdersCount(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActiveOrdersCount(<any>response_);
                        } catch (e) {
                            return <Observable<GetActiveOrdersCountOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetActiveOrdersCountOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActiveOrdersCount(response: HttpResponseBase): Observable<GetActiveOrdersCountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetActiveOrdersCountOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetActiveOrdersCountOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getOrderForEdit(id: number | undefined): Observable<OrderEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<OrderEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderForEdit(response: HttpResponseBase): Observable<OrderEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrderEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getOrderForView(id: number | undefined): Observable<OrderViewDto> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderForView?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderForView(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderForView(<any>response_);
                        } catch (e) {
                            return <Observable<OrderViewDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderViewDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderForView(response: HttpResponseBase): Observable<OrderViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrderViewDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderViewDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getCustomerListForOrder(input: string | undefined): Observable<CustomerEditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetCustomerListForOrder?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerListForOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerListForOrder(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerEditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerEditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerListForOrder(response: HttpResponseBase): Observable<CustomerEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerEditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerEditDto[]>([]);
    }

    /**
     * @return Success
     */
    getCustomerLocationListForOrder(): Observable<CustomerLocationEditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetCustomerLocationListForOrder';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocationListForOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocationListForOrder(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationEditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationEditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocationListForOrder(response: HttpResponseBase): Observable<CustomerLocationEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerLocationEditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationEditDto[]>([]);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getOrderForInquiry(orderId: number | undefined): Observable<OrderInquiryTicketDto> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderForInquiry?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderForInquiry(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderForInquiry(<any>response_);
                        } catch (e) {
                            return <Observable<OrderInquiryTicketDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderInquiryTicketDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderForInquiry(response: HttpResponseBase): Observable<OrderInquiryTicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrderInquiryTicketDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderInquiryTicketDto>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param body (optional)
     * @return Success
     */
    createOrder(ticketId: number | undefined, body: OrderEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Order/CreateOrder?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrder(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateOrder(body: OrderEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Order/UpdateOrder';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateOrder(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateOrderDetail(body: OrderDetailsListDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/CreateOrUpdateOrderDetail';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateOrderDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateOrderDetail(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateOrderDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    isOrderProvisioned(orderId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Order/IsOrderProvisioned?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processIsOrderProvisioned(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processIsOrderProvisioned(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processIsOrderProvisioned(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param locationId (optional)
     * @param orderId (optional)
     * @return Success
     */
    checkInputPresentInDB(locationId: number | undefined, orderId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Order/CheckInputPresentInDB?';
        if (locationId === null) throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined) url_ += 'locationId=' + encodeURIComponent('' + locationId) + '&';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'OrderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckInputPresentInDB(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckInputPresentInDB(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCheckInputPresentInDB(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param productId (optional)
     * @param locationId (optional)
     * @return Success
     */
    checkProductInputPresentInDB(productId: number | undefined, locationId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Order/CheckProductInputPresentInDB?';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        if (locationId === null) throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined) url_ += 'locationId=' + encodeURIComponent('' + locationId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckProductInputPresentInDB(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckProductInputPresentInDB(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCheckProductInputPresentInDB(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateOrderLocationDetailContract(body: OrderLocationDetailContractEditDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/CreateOrUpdateOrderLocationDetailContract';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateOrderLocationDetailContract(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateOrderLocationDetailContract(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateOrderLocationDetailContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrderLocationDetailContract(body: OrderLocationDetailContractEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/CreateOrderLocationDetailContract';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrderLocationDetailContract(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrderLocationDetailContract(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrderLocationDetailContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param internalSalesAgentId (optional)
     * @return Success
     */
    updateOrderInternalSalesAgent(orderId: number | undefined, internalSalesAgentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/UpdateOrderInternalSalesAgent?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        if (internalSalesAgentId === null) throw new Error("The parameter 'internalSalesAgentId' cannot be null.");
        else if (internalSalesAgentId !== undefined) url_ += 'internalSalesAgentId=' + encodeURIComponent('' + internalSalesAgentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateOrderInternalSalesAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateOrderInternalSalesAgent(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateOrderInternalSalesAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getOrderStatusList(): Observable<OrderStatusEditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderStatusList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<OrderStatusEditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderStatusEditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderStatusList(response: HttpResponseBase): Observable<OrderStatusEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderStatusEditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderStatusEditDto[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getDashboardSales(partnerId: number | undefined): Observable<DashboardSalesOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetDashboardSales?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDashboardSales(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDashboardSales(<any>response_);
                        } catch (e) {
                            return <Observable<DashboardSalesOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DashboardSalesOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDashboardSales(response: HttpResponseBase): Observable<DashboardSalesOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DashboardSalesOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DashboardSalesOutput[]>([]);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    submitOrder(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/SubmitOrder?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSubmitOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSubmitOrder(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSubmitOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @param providerId (optional)
     * @return Success
     */
    getTotalOpenOrdersDashboard(partnerId: number | undefined, providerId: number | undefined): Observable<OpenOrdersDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetTotalOpenOrdersDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTotalOpenOrdersDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTotalOpenOrdersDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OpenOrdersDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpenOrdersDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTotalOpenOrdersDashboard(response: HttpResponseBase): Observable<OpenOrdersDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpenOrdersDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpenOrdersDashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param supportId (optional)
     * @return Success
     */
    getSalesLast13Dashboard(partnerId: number | undefined, supportId: number | undefined): Observable<SalesLast13DashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetSalesLast13Dashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'supportId=' + encodeURIComponent('' + supportId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesLast13Dashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesLast13Dashboard(<any>response_);
                        } catch (e) {
                            return <Observable<SalesLast13DashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesLast13DashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesLast13Dashboard(response: HttpResponseBase): Observable<SalesLast13DashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesLast13DashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesLast13DashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getSalesLast18Dashboard(partnerId: number | undefined): Observable<SalesLast18DashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetSalesLast18Dashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesLast18Dashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesLast18Dashboard(<any>response_);
                        } catch (e) {
                            return <Observable<SalesLast18DashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesLast18DashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesLast18Dashboard(response: HttpResponseBase): Observable<SalesLast18DashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesLast18DashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesLast18DashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param supportId (optional)
     * @return Success
     */
    getSalesLast13ByProviderDashboard(
        partnerId: number | undefined,
        supportId: number | undefined
    ): Observable<SalesLast18DashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetSalesLast13ByProviderDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'supportId=' + encodeURIComponent('' + supportId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesLast13ByProviderDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesLast13ByProviderDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<SalesLast18DashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesLast18DashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesLast13ByProviderDashboard(response: HttpResponseBase): Observable<SalesLast18DashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesLast18DashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesLast18DashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getSalesLast18ByProviderDashboard(partnerId: number | undefined): Observable<SalesLast18DashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetSalesLast18ByProviderDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesLast18ByProviderDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesLast18ByProviderDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<SalesLast18DashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesLast18DashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesLast18ByProviderDashboard(response: HttpResponseBase): Observable<SalesLast18DashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesLast18DashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesLast18DashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param supportId (optional)
     * @return Success
     */
    getSalesLast13ByProductDashboard(
        partnerId: number | undefined,
        supportId: number | undefined
    ): Observable<SalesLast13ByProductDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetSalesLast13ByProductDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'supportId=' + encodeURIComponent('' + supportId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesLast13ByProductDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesLast13ByProductDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<SalesLast13ByProductDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesLast13ByProductDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesLast13ByProductDashboard(response: HttpResponseBase): Observable<SalesLast13ByProductDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesLast13ByProductDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesLast13ByProductDashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     */
    getCustomersSalesDashboard(partnerId: number | undefined, spmId: number | undefined): Observable<CustomersSalesDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetCustomersSalesDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomersSalesDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomersSalesDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<CustomersSalesDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomersSalesDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomersSalesDashboard(response: HttpResponseBase): Observable<CustomersSalesDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomersSalesDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomersSalesDashboardOutput[]>([]);
    }

    /**
     * @param supportId (optional)
     * @return Success
     */
    getActivityPartnerSalesDashboard(supportId: number | undefined): Observable<ActivityPartnerSalesDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetActivityPartnerSalesDashboard?';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'supportId=' + encodeURIComponent('' + supportId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActivityPartnerSalesDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActivityPartnerSalesDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<ActivityPartnerSalesDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ActivityPartnerSalesDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActivityPartnerSalesDashboard(response: HttpResponseBase): Observable<ActivityPartnerSalesDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ActivityPartnerSalesDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ActivityPartnerSalesDashboardOutput[]>([]);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param paramPartnerList (optional)
     * @param paramProviderList (optional)
     * @param paramSPMList (optional)
     * @param paramProductList (optional)
     * @param paramProdCategoryList (optional)
     * @param paramInvestOwnerList (optional)
     * @return Success
     */
    getReportDetailsSalesToExcel(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        paramPartnerList: string | undefined,
        paramProviderList: string | undefined,
        paramSPMList: string | undefined,
        paramProductList: string | undefined,
        paramProdCategoryList: string | undefined,
        paramInvestOwnerList: string | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetReportDetailsSalesToExcel?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (paramPartnerList === null) throw new Error("The parameter 'paramPartnerList' cannot be null.");
        else if (paramPartnerList !== undefined) url_ += 'paramPartnerList=' + encodeURIComponent('' + paramPartnerList) + '&';
        if (paramProviderList === null) throw new Error("The parameter 'paramProviderList' cannot be null.");
        else if (paramProviderList !== undefined) url_ += 'paramProviderList=' + encodeURIComponent('' + paramProviderList) + '&';
        if (paramSPMList === null) throw new Error("The parameter 'paramSPMList' cannot be null.");
        else if (paramSPMList !== undefined) url_ += 'paramSPMList=' + encodeURIComponent('' + paramSPMList) + '&';
        if (paramProductList === null) throw new Error("The parameter 'paramProductList' cannot be null.");
        else if (paramProductList !== undefined) url_ += 'paramProductList=' + encodeURIComponent('' + paramProductList) + '&';
        if (paramProdCategoryList === null) throw new Error("The parameter 'paramProdCategoryList' cannot be null.");
        else if (paramProdCategoryList !== undefined)
            url_ += 'paramProdCategoryList=' + encodeURIComponent('' + paramProdCategoryList) + '&';
        if (paramInvestOwnerList === null) throw new Error("The parameter 'paramInvestOwnerList' cannot be null.");
        else if (paramInvestOwnerList !== undefined) url_ += 'paramInvestOwnerList=' + encodeURIComponent('' + paramInvestOwnerList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportDetailsSalesToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportDetailsSalesToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportDetailsSalesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param paramPartnerList (optional)
     * @param paramProviderList (optional)
     * @param paramSPMList (optional)
     * @param paramProductList (optional)
     * @param paramProdCategoryList (optional)
     * @param paramInvestOwnerList (optional)
     * @return Success
     */
    getReportDetailsSales(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        paramPartnerList: string | undefined,
        paramProviderList: string | undefined,
        paramSPMList: string | undefined,
        paramProductList: string | undefined,
        paramProdCategoryList: string | undefined,
        paramInvestOwnerList: string | undefined
    ): Observable<OutputReportDetailsSales[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetReportDetailsSales?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (paramPartnerList === null) throw new Error("The parameter 'paramPartnerList' cannot be null.");
        else if (paramPartnerList !== undefined) url_ += 'paramPartnerList=' + encodeURIComponent('' + paramPartnerList) + '&';
        if (paramProviderList === null) throw new Error("The parameter 'paramProviderList' cannot be null.");
        else if (paramProviderList !== undefined) url_ += 'paramProviderList=' + encodeURIComponent('' + paramProviderList) + '&';
        if (paramSPMList === null) throw new Error("The parameter 'paramSPMList' cannot be null.");
        else if (paramSPMList !== undefined) url_ += 'paramSPMList=' + encodeURIComponent('' + paramSPMList) + '&';
        if (paramProductList === null) throw new Error("The parameter 'paramProductList' cannot be null.");
        else if (paramProductList !== undefined) url_ += 'paramProductList=' + encodeURIComponent('' + paramProductList) + '&';
        if (paramProdCategoryList === null) throw new Error("The parameter 'paramProdCategoryList' cannot be null.");
        else if (paramProdCategoryList !== undefined)
            url_ += 'paramProdCategoryList=' + encodeURIComponent('' + paramProdCategoryList) + '&';
        if (paramInvestOwnerList === null) throw new Error("The parameter 'paramInvestOwnerList' cannot be null.");
        else if (paramInvestOwnerList !== undefined) url_ += 'paramInvestOwnerList=' + encodeURIComponent('' + paramInvestOwnerList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportDetailsSales(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportDetailsSales(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportDetailsSales[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportDetailsSales[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportDetailsSales(response: HttpResponseBase): Observable<OutputReportDetailsSales[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportDetailsSales.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportDetailsSales[]>([]);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param searchType (optional)
     * @param reportType (optional)
     * @param paramPartnerList (optional)
     * @param paramProviderList (optional)
     * @param paramSPMList (optional)
     * @param paramProductList (optional)
     * @param paramProdCategoryList (optional)
     * @param paramInvestOwnerList (optional)
     * @return Success
     */
    getReportTrendingSales(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        searchType: string | undefined,
        reportType: string | undefined,
        paramPartnerList: string | undefined,
        paramProviderList: string | undefined,
        paramSPMList: string | undefined,
        paramProductList: string | undefined,
        paramProdCategoryList: string | undefined,
        paramInvestOwnerList: string | undefined
    ): Observable<OutputReportTrendingSales[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetReportTrendingSales?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (searchType === null) throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined) url_ += 'searchType=' + encodeURIComponent('' + searchType) + '&';
        if (reportType === null) throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined) url_ += 'reportType=' + encodeURIComponent('' + reportType) + '&';
        if (paramPartnerList === null) throw new Error("The parameter 'paramPartnerList' cannot be null.");
        else if (paramPartnerList !== undefined) url_ += 'paramPartnerList=' + encodeURIComponent('' + paramPartnerList) + '&';
        if (paramProviderList === null) throw new Error("The parameter 'paramProviderList' cannot be null.");
        else if (paramProviderList !== undefined) url_ += 'paramProviderList=' + encodeURIComponent('' + paramProviderList) + '&';
        if (paramSPMList === null) throw new Error("The parameter 'paramSPMList' cannot be null.");
        else if (paramSPMList !== undefined) url_ += 'paramSPMList=' + encodeURIComponent('' + paramSPMList) + '&';
        if (paramProductList === null) throw new Error("The parameter 'paramProductList' cannot be null.");
        else if (paramProductList !== undefined) url_ += 'paramProductList=' + encodeURIComponent('' + paramProductList) + '&';
        if (paramProdCategoryList === null) throw new Error("The parameter 'paramProdCategoryList' cannot be null.");
        else if (paramProdCategoryList !== undefined)
            url_ += 'paramProdCategoryList=' + encodeURIComponent('' + paramProdCategoryList) + '&';
        if (paramInvestOwnerList === null) throw new Error("The parameter 'paramInvestOwnerList' cannot be null.");
        else if (paramInvestOwnerList !== undefined) url_ += 'paramInvestOwnerList=' + encodeURIComponent('' + paramInvestOwnerList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportTrendingSales(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportTrendingSales(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportTrendingSales[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportTrendingSales[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportTrendingSales(response: HttpResponseBase): Observable<OutputReportTrendingSales[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportTrendingSales.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportTrendingSales[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getPartnerSalesDashboard(partnerId: number | undefined): Observable<PartnerSalesDashboardOutput> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetPartnerSalesDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSalesDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSalesDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerSalesDashboardOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerSalesDashboardOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSalesDashboard(response: HttpResponseBase): Observable<PartnerSalesDashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerSalesDashboardOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerSalesDashboardOutput>(<any>null);
    }

    /**
     * @param providerInput (optional)
     * @param partnerId (optional)
     * @param customerIds (optional)
     * @return Success
     */
    getReportDetailedOrderTracking(providerInput: string | undefined, partnerId: number | undefined, customerIds: string | undefined): Observable<OutputReportDetailedOrderTracking[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportDetailedOrderTracking?";
        if (providerInput === null)
            throw new Error("The parameter 'providerInput' cannot be null.");
        else if (providerInput !== undefined)
            url_ += "providerInput=" + encodeURIComponent("" + providerInput) + "&";
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            url_ += "customerIds=" + encodeURIComponent("" + customerIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_ : any) => {
                    return this.processGetReportDetailedOrderTracking(response_);
                })
        )
        .pipe(
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetReportDetailedOrderTracking(<any>response_);
                    } catch (e) {
                        return <Observable<OutputReportDetailedOrderTracking[]>><any>_observableThrow(e);
                    }
                } else return <Observable<OutputReportDetailedOrderTracking[]>><any>_observableThrow(response_);
            })
        );
    }

    protected processGetReportDetailedOrderTracking(response: HttpResponseBase): Observable<OutputReportDetailedOrderTracking[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(OutputReportDetailedOrderTracking.fromJS(item));
                }
                return _observableOf(result200);
            })
        );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap(_responseText => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportDetailedOrderTracking[]>([]);
    }

    /**
     * @param providerInput (optional)
     * @param orderStatusType (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param productCategoryInput (optional)
     * @param productInput (optional)
     * @return Success
     */
    getReportExecSummProviderSales(
        providerInput: string | undefined,
        orderStatusType: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        productCategoryInput: string | undefined,
        productInput: string | undefined
    ): Observable<OutputReportExecSummProviderSales[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetReportExecSummProviderSales?';
        if (providerInput === null) throw new Error("The parameter 'providerInput' cannot be null.");
        else if (providerInput !== undefined) url_ += 'providerInput=' + encodeURIComponent('' + providerInput) + '&';
        if (orderStatusType === null) throw new Error("The parameter 'orderStatusType' cannot be null.");
        else if (orderStatusType !== undefined) url_ += 'orderStatusType=' + encodeURIComponent('' + orderStatusType) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (productCategoryInput === null) throw new Error("The parameter 'productCategoryInput' cannot be null.");
        else if (productCategoryInput !== undefined) url_ += 'productCategoryInput=' + encodeURIComponent('' + productCategoryInput) + '&';
        if (productInput === null) throw new Error("The parameter 'productInput' cannot be null.");
        else if (productInput !== undefined) url_ += 'productInput=' + encodeURIComponent('' + productInput) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummProviderSales(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummProviderSales(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummProviderSales[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummProviderSales[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummProviderSales(response: HttpResponseBase): Observable<OutputReportExecSummProviderSales[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummProviderSales.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummProviderSales[]>([]);
    }

    /**
     * @param partnerInput (optional)
     * @param orderStatusType (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param productCategoryInput (optional)
     * @param productInput (optional)
     * @return Success
     */
    getReportExecSummPartnerSales(
        partnerInput: string | undefined,
        orderStatusType: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        productCategoryInput: string | undefined,
        productInput: string | undefined
    ): Observable<OutputReportExecSummPartnerSales[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetReportExecSummPartnerSales?';
        if (partnerInput === null) throw new Error("The parameter 'partnerInput' cannot be null.");
        else if (partnerInput !== undefined) url_ += 'partnerInput=' + encodeURIComponent('' + partnerInput) + '&';
        if (orderStatusType === null) throw new Error("The parameter 'orderStatusType' cannot be null.");
        else if (orderStatusType !== undefined) url_ += 'orderStatusType=' + encodeURIComponent('' + orderStatusType) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (productCategoryInput === null) throw new Error("The parameter 'productCategoryInput' cannot be null.");
        else if (productCategoryInput !== undefined) url_ += 'productCategoryInput=' + encodeURIComponent('' + productCategoryInput) + '&';
        if (productInput === null) throw new Error("The parameter 'productInput' cannot be null.");
        else if (productInput !== undefined) url_ += 'productInput=' + encodeURIComponent('' + productInput) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummPartnerSales(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummPartnerSales(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummPartnerSales[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummPartnerSales[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummPartnerSales(response: HttpResponseBase): Observable<OutputReportExecSummPartnerSales[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummPartnerSales.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummPartnerSales[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getPartnerCustomerSalesDashboard(partnerId: number | undefined): Observable<PartnerCustomerSalesDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetPartnerCustomerSalesDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerCustomerSalesDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerCustomerSalesDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerCustomerSalesDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerCustomerSalesDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerCustomerSalesDashboard(response: HttpResponseBase): Observable<PartnerCustomerSalesDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerCustomerSalesDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerCustomerSalesDashboardOutput[]>([]);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getOrdersSupportUsersDashboard(userId: number | undefined): Observable<OrdersSupportUsersDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrdersSupportUsersDashboard?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrdersSupportUsersDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrdersSupportUsersDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OrdersSupportUsersDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrdersSupportUsersDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrdersSupportUsersDashboard(response: HttpResponseBase): Observable<OrdersSupportUsersDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrdersSupportUsersDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrdersSupportUsersDashboardOutput[]>([]);
    }

    /**
     * @param userId (optional)
     * @param partnerId (optional)
     * @return Success
     */
    getOpenOrdersAgingDashboard(userId: number | undefined, partnerId: number | undefined): Observable<OpenOrdersAgingDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOpenOrdersAgingDashboard?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpenOrdersAgingDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpenOrdersAgingDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OpenOrdersAgingDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpenOrdersAgingDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpenOrdersAgingDashboard(response: HttpResponseBase): Observable<OpenOrdersAgingDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpenOrdersAgingDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpenOrdersAgingDashboardOutput[]>([]);
    }

    /**
     * @param assignedUserIds (optional)
     * @param providerIds (optional)
     * @param productIds (optional)
     * @param supervisorId (optional)
     * @return Success
     */
    getOrdersAgingDashboard(
        assignedUserIds: number[] | undefined,
        providerIds: number[] | undefined,
        productIds: number[] | undefined,
        supervisorId: number | undefined
    ): Observable<OrdersAgingDashboardDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrdersAgingDashboard?';
        if (assignedUserIds === null) throw new Error("The parameter 'assignedUserIds' cannot be null.");
        else if (assignedUserIds !== undefined)
            assignedUserIds &&
                assignedUserIds.forEach((item) => {
                    url_ += 'assignedUserIds=' + encodeURIComponent('' + item) + '&';
                });
        if (providerIds === null) throw new Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined)
            providerIds &&
                providerIds.forEach((item) => {
                    url_ += 'providerIds=' + encodeURIComponent('' + item) + '&';
                });
        if (productIds === null) throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds &&
                productIds.forEach((item) => {
                    url_ += 'productIds=' + encodeURIComponent('' + item) + '&';
                });
        if (supervisorId === null) throw new Error("The parameter 'supervisorId' cannot be null.");
        else if (supervisorId !== undefined) url_ += 'supervisorId=' + encodeURIComponent('' + supervisorId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrdersAgingDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrdersAgingDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OrdersAgingDashboardDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrdersAgingDashboardDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrdersAgingDashboard(response: HttpResponseBase): Observable<OrdersAgingDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrdersAgingDashboardDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrdersAgingDashboardDto[]>([]);
    }

    /**
     * @param orderNumber (optional)
     * @param billingAcountNumber (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param orderStatusTypeIds (optional)
     * @param statusStartDate (optional)
     * @param statusEndDate (optional)
     * @param contractStartDate (optional)
     * @param contractEndDate (optional)
     * @param partnerId (optional)
     * @param customerId (optional)
     * @param customerLocationId (optional)
     * @param providerId (optional)
     * @param productCategoryId (optional)
     * @param productId (optional)
     * @param spmIdList (optional)
     * @param investOwnersIdList (optional)
     * @param provisionerIdList (optional)
     * @param agentIdList (optional)
     * @param orderStatusIdList (optional)
     * @param contractTypeIdList (optional)
     * @param ignoreCache (optional)
     * @param advisorEntitlementId (optional)
     * @param salesCampaignIdList (optional)
     * @param internalSalesAgentIdList (optional)
     * @param accountManagerIdList (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrdersTotalsForTable(
        orderNumber: string | undefined,
        billingAcountNumber: string | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        orderStatusTypeIds: string | undefined,
        statusStartDate: moment.Moment | undefined,
        statusEndDate: moment.Moment | undefined,
        contractStartDate: moment.Moment | undefined,
        contractEndDate: moment.Moment | undefined,
        partnerId: string | undefined,
        customerId: string | undefined,
        customerLocationId: string | undefined,
        providerId: string | undefined,
        productCategoryId: string | undefined,
        productId: string | undefined,
        spmIdList: string | undefined,
        investOwnersIdList: string | undefined,
        provisionerIdList: string | undefined,
        agentIdList: string | undefined,
        orderStatusIdList: string | undefined,
        contractTypeIdList: string | undefined,
        ignoreCache: boolean | undefined,
        advisorEntitlementId: number | undefined,
        salesCampaignIdList: string | undefined,
        internalSalesAgentIdList: string | undefined,
        accountManagerIdList: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<OrderListTotals> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrdersTotalsForTable?';
        if (orderNumber === null) throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined) url_ += 'OrderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (billingAcountNumber === null) throw new Error("The parameter 'billingAcountNumber' cannot be null.");
        else if (billingAcountNumber !== undefined) url_ += 'BillingAcountNumber=' + encodeURIComponent('' + billingAcountNumber) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (orderStatusTypeIds === null) throw new Error("The parameter 'orderStatusTypeIds' cannot be null.");
        else if (orderStatusTypeIds !== undefined) url_ += 'OrderStatusTypeIds=' + encodeURIComponent('' + orderStatusTypeIds) + '&';
        if (statusStartDate === null) throw new Error("The parameter 'statusStartDate' cannot be null.");
        else if (statusStartDate !== undefined)
            url_ += 'StatusStartDate=' + encodeURIComponent(statusStartDate ? '' + statusStartDate.toJSON() : '') + '&';
        if (statusEndDate === null) throw new Error("The parameter 'statusEndDate' cannot be null.");
        else if (statusEndDate !== undefined)
            url_ += 'StatusEndDate=' + encodeURIComponent(statusEndDate ? '' + statusEndDate.toJSON() : '') + '&';
        if (contractStartDate === null) throw new Error("The parameter 'contractStartDate' cannot be null.");
        else if (contractStartDate !== undefined)
            url_ += 'ContractStartDate=' + encodeURIComponent(contractStartDate ? '' + contractStartDate.toJSON() : '') + '&';
        if (contractEndDate === null) throw new Error("The parameter 'contractEndDate' cannot be null.");
        else if (contractEndDate !== undefined)
            url_ += 'ContractEndDate=' + encodeURIComponent(contractEndDate ? '' + contractEndDate.toJSON() : '') + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (customerLocationId === null) throw new Error("The parameter 'customerLocationId' cannot be null.");
        else if (customerLocationId !== undefined) url_ += 'CustomerLocationId=' + encodeURIComponent('' + customerLocationId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (productCategoryId === null) throw new Error("The parameter 'productCategoryId' cannot be null.");
        else if (productCategoryId !== undefined) url_ += 'ProductCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        if (spmIdList === null) throw new Error("The parameter 'spmIdList' cannot be null.");
        else if (spmIdList !== undefined) url_ += 'SpmIdList=' + encodeURIComponent('' + spmIdList) + '&';
        if (investOwnersIdList === null) throw new Error("The parameter 'investOwnersIdList' cannot be null.");
        else if (investOwnersIdList !== undefined) url_ += 'InvestOwnersIdList=' + encodeURIComponent('' + investOwnersIdList) + '&';
        if (provisionerIdList === null) throw new Error("The parameter 'provisionerIdList' cannot be null.");
        else if (provisionerIdList !== undefined) url_ += 'ProvisionerIdList=' + encodeURIComponent('' + provisionerIdList) + '&';
        if (agentIdList === null) throw new Error("The parameter 'agentIdList' cannot be null.");
        else if (agentIdList !== undefined) url_ += 'AgentIdList=' + encodeURIComponent('' + agentIdList) + '&';
        if (orderStatusIdList === null) throw new Error("The parameter 'orderStatusIdList' cannot be null.");
        else if (orderStatusIdList !== undefined) url_ += 'OrderStatusIdList=' + encodeURIComponent('' + orderStatusIdList) + '&';
        if (contractTypeIdList === null) throw new Error("The parameter 'contractTypeIdList' cannot be null.");
        else if (contractTypeIdList !== undefined) url_ += 'ContractTypeIdList=' + encodeURIComponent('' + contractTypeIdList) + '&';
        if (ignoreCache === null) throw new Error("The parameter 'ignoreCache' cannot be null.");
        else if (ignoreCache !== undefined) url_ += 'IgnoreCache=' + encodeURIComponent('' + ignoreCache) + '&';
        if (advisorEntitlementId === null) throw new Error("The parameter 'advisorEntitlementId' cannot be null.");
        else if (advisorEntitlementId !== undefined) url_ += 'AdvisorEntitlementId=' + encodeURIComponent('' + advisorEntitlementId) + '&';
        if (salesCampaignIdList === null) throw new Error("The parameter 'salesCampaignIdList' cannot be null.");
        else if (salesCampaignIdList !== undefined) url_ += 'SalesCampaignIdList=' + encodeURIComponent('' + salesCampaignIdList) + '&';
        if (internalSalesAgentIdList === null) throw new Error("The parameter 'internalSalesAgentIdList' cannot be null.");
        else if (internalSalesAgentIdList !== undefined)
            url_ += 'InternalSalesAgentIdList=' + encodeURIComponent('' + internalSalesAgentIdList) + '&';
        if (accountManagerIdList === null) throw new Error("The parameter 'accountManagerIdList' cannot be null.");
        else if (accountManagerIdList !== undefined) url_ += 'AccountManagerIdList=' + encodeURIComponent('' + accountManagerIdList) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrdersTotalsForTable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrdersTotalsForTable(<any>response_);
                        } catch (e) {
                            return <Observable<OrderListTotals>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderListTotals>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrdersTotalsForTable(response: HttpResponseBase): Observable<OrderListTotals> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrderListTotals.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderListTotals>(<any>null);
    }

    /**
     * @param orderNumber (optional)
     * @param billingAcountNumber (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param orderStatusTypeIds (optional)
     * @param statusStartDate (optional)
     * @param statusEndDate (optional)
     * @param contractStartDate (optional)
     * @param contractEndDate (optional)
     * @param partnerId (optional)
     * @param customerId (optional)
     * @param customerLocationId (optional)
     * @param providerId (optional)
     * @param productCategoryId (optional)
     * @param productId (optional)
     * @param spmIdList (optional)
     * @param investOwnersIdList (optional)
     * @param provisionerIdList (optional)
     * @param agentIdList (optional)
     * @param orderStatusIdList (optional)
     * @param contractTypeIdList (optional)
     * @param ignoreCache (optional)
     * @param advisorEntitlementId (optional)
     * @param salesCampaignIdList (optional)
     * @param internalSalesAgentIdList (optional)
     * @param accountManagerIdList (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrdersForTable(
        orderNumber: string | undefined,
        billingAcountNumber: string | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        orderStatusTypeIds: string | undefined,
        statusStartDate: moment.Moment | undefined,
        statusEndDate: moment.Moment | undefined,
        contractStartDate: moment.Moment | undefined,
        contractEndDate: moment.Moment | undefined,
        partnerId: string | undefined,
        customerId: string | undefined,
        customerLocationId: string | undefined,
        providerId: string | undefined,
        productCategoryId: string | undefined,
        productId: string | undefined,
        spmIdList: string | undefined,
        investOwnersIdList: string | undefined,
        provisionerIdList: string | undefined,
        agentIdList: string | undefined,
        orderStatusIdList: string | undefined,
        contractTypeIdList: string | undefined,
        ignoreCache: boolean | undefined,
        advisorEntitlementId: number | undefined,
        salesCampaignIdList: string | undefined,
        internalSalesAgentIdList: string | undefined,
        accountManagerIdList: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<OrderListOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrdersForTable?';
        if (orderNumber === null) throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined) url_ += 'OrderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (billingAcountNumber === null) throw new Error("The parameter 'billingAcountNumber' cannot be null.");
        else if (billingAcountNumber !== undefined) url_ += 'BillingAcountNumber=' + encodeURIComponent('' + billingAcountNumber) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (orderStatusTypeIds === null) throw new Error("The parameter 'orderStatusTypeIds' cannot be null.");
        else if (orderStatusTypeIds !== undefined) url_ += 'OrderStatusTypeIds=' + encodeURIComponent('' + orderStatusTypeIds) + '&';
        if (statusStartDate === null) throw new Error("The parameter 'statusStartDate' cannot be null.");
        else if (statusStartDate !== undefined)
            url_ += 'StatusStartDate=' + encodeURIComponent(statusStartDate ? '' + statusStartDate.toJSON() : '') + '&';
        if (statusEndDate === null) throw new Error("The parameter 'statusEndDate' cannot be null.");
        else if (statusEndDate !== undefined)
            url_ += 'StatusEndDate=' + encodeURIComponent(statusEndDate ? '' + statusEndDate.toJSON() : '') + '&';
        if (contractStartDate === null) throw new Error("The parameter 'contractStartDate' cannot be null.");
        else if (contractStartDate !== undefined)
            url_ += 'ContractStartDate=' + encodeURIComponent(contractStartDate ? '' + contractStartDate.toJSON() : '') + '&';
        if (contractEndDate === null) throw new Error("The parameter 'contractEndDate' cannot be null.");
        else if (contractEndDate !== undefined)
            url_ += 'ContractEndDate=' + encodeURIComponent(contractEndDate ? '' + contractEndDate.toJSON() : '') + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (customerLocationId === null) throw new Error("The parameter 'customerLocationId' cannot be null.");
        else if (customerLocationId !== undefined) url_ += 'CustomerLocationId=' + encodeURIComponent('' + customerLocationId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (productCategoryId === null) throw new Error("The parameter 'productCategoryId' cannot be null.");
        else if (productCategoryId !== undefined) url_ += 'ProductCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        if (spmIdList === null) throw new Error("The parameter 'spmIdList' cannot be null.");
        else if (spmIdList !== undefined) url_ += 'SpmIdList=' + encodeURIComponent('' + spmIdList) + '&';
        if (investOwnersIdList === null) throw new Error("The parameter 'investOwnersIdList' cannot be null.");
        else if (investOwnersIdList !== undefined) url_ += 'InvestOwnersIdList=' + encodeURIComponent('' + investOwnersIdList) + '&';
        if (provisionerIdList === null) throw new Error("The parameter 'provisionerIdList' cannot be null.");
        else if (provisionerIdList !== undefined) url_ += 'ProvisionerIdList=' + encodeURIComponent('' + provisionerIdList) + '&';
        if (agentIdList === null) throw new Error("The parameter 'agentIdList' cannot be null.");
        else if (agentIdList !== undefined) url_ += 'AgentIdList=' + encodeURIComponent('' + agentIdList) + '&';
        if (orderStatusIdList === null) throw new Error("The parameter 'orderStatusIdList' cannot be null.");
        else if (orderStatusIdList !== undefined) url_ += 'OrderStatusIdList=' + encodeURIComponent('' + orderStatusIdList) + '&';
        if (contractTypeIdList === null) throw new Error("The parameter 'contractTypeIdList' cannot be null.");
        else if (contractTypeIdList !== undefined) url_ += 'ContractTypeIdList=' + encodeURIComponent('' + contractTypeIdList) + '&';
        if (ignoreCache === null) throw new Error("The parameter 'ignoreCache' cannot be null.");
        else if (ignoreCache !== undefined) url_ += 'IgnoreCache=' + encodeURIComponent('' + ignoreCache) + '&';
        if (advisorEntitlementId === null) throw new Error("The parameter 'advisorEntitlementId' cannot be null.");
        else if (advisorEntitlementId !== undefined) url_ += 'AdvisorEntitlementId=' + encodeURIComponent('' + advisorEntitlementId) + '&';
        if (salesCampaignIdList === null) throw new Error("The parameter 'salesCampaignIdList' cannot be null.");
        else if (salesCampaignIdList !== undefined) url_ += 'SalesCampaignIdList=' + encodeURIComponent('' + salesCampaignIdList) + '&';
        if (internalSalesAgentIdList === null) throw new Error("The parameter 'internalSalesAgentIdList' cannot be null.");
        else if (internalSalesAgentIdList !== undefined)
            url_ += 'InternalSalesAgentIdList=' + encodeURIComponent('' + internalSalesAgentIdList) + '&';
        if (accountManagerIdList === null) throw new Error("The parameter 'accountManagerIdList' cannot be null.");
        else if (accountManagerIdList !== undefined) url_ += 'AccountManagerIdList=' + encodeURIComponent('' + accountManagerIdList) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrdersForTable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrdersForTable(<any>response_);
                        } catch (e) {
                            return <Observable<OrderListOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderListOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrdersForTable(response: HttpResponseBase): Observable<OrderListOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderListOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderListOutput[]>([]);
    }

    /**
     * @param orderNumber (optional)
     * @param billingAcountNumber (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param orderStatusTypeIds (optional)
     * @param statusStartDate (optional)
     * @param statusEndDate (optional)
     * @param contractStartDate (optional)
     * @param contractEndDate (optional)
     * @param partnerId (optional)
     * @param customerId (optional)
     * @param customerLocationId (optional)
     * @param providerId (optional)
     * @param productCategoryId (optional)
     * @param productId (optional)
     * @param spmIdList (optional)
     * @param investOwnersIdList (optional)
     * @param provisionerIdList (optional)
     * @param agentIdList (optional)
     * @param orderStatusIdList (optional)
     * @param contractTypeIdList (optional)
     * @param ignoreCache (optional)
     * @param advisorEntitlementId (optional)
     * @param salesCampaignIdList (optional)
     * @param internalSalesAgentIdList (optional)
     * @param accountManagerIdList (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrdersForTableReport(
        orderNumber: string | undefined,
        billingAcountNumber: string | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        orderStatusTypeIds: string | undefined,
        statusStartDate: moment.Moment | undefined,
        statusEndDate: moment.Moment | undefined,
        contractStartDate: moment.Moment | undefined,
        contractEndDate: moment.Moment | undefined,
        partnerId: string | undefined,
        customerId: string | undefined,
        customerLocationId: string | undefined,
        providerId: string | undefined,
        productCategoryId: string | undefined,
        productId: string | undefined,
        spmIdList: string | undefined,
        investOwnersIdList: string | undefined,
        provisionerIdList: string | undefined,
        agentIdList: string | undefined,
        orderStatusIdList: string | undefined,
        contractTypeIdList: string | undefined,
        ignoreCache: boolean | undefined,
        advisorEntitlementId: number | undefined,
        salesCampaignIdList: string | undefined,
        internalSalesAgentIdList: string | undefined,
        accountManagerIdList: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<OrderListOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrdersForTableReport?';
        if (orderNumber === null) throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined) url_ += 'OrderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (billingAcountNumber === null) throw new Error("The parameter 'billingAcountNumber' cannot be null.");
        else if (billingAcountNumber !== undefined) url_ += 'BillingAcountNumber=' + encodeURIComponent('' + billingAcountNumber) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (orderStatusTypeIds === null) throw new Error("The parameter 'orderStatusTypeIds' cannot be null.");
        else if (orderStatusTypeIds !== undefined) url_ += 'OrderStatusTypeIds=' + encodeURIComponent('' + orderStatusTypeIds) + '&';
        if (statusStartDate === null) throw new Error("The parameter 'statusStartDate' cannot be null.");
        else if (statusStartDate !== undefined)
            url_ += 'StatusStartDate=' + encodeURIComponent(statusStartDate ? '' + statusStartDate.toJSON() : '') + '&';
        if (statusEndDate === null) throw new Error("The parameter 'statusEndDate' cannot be null.");
        else if (statusEndDate !== undefined)
            url_ += 'StatusEndDate=' + encodeURIComponent(statusEndDate ? '' + statusEndDate.toJSON() : '') + '&';
        if (contractStartDate === null) throw new Error("The parameter 'contractStartDate' cannot be null.");
        else if (contractStartDate !== undefined)
            url_ += 'ContractStartDate=' + encodeURIComponent(contractStartDate ? '' + contractStartDate.toJSON() : '') + '&';
        if (contractEndDate === null) throw new Error("The parameter 'contractEndDate' cannot be null.");
        else if (contractEndDate !== undefined)
            url_ += 'ContractEndDate=' + encodeURIComponent(contractEndDate ? '' + contractEndDate.toJSON() : '') + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (customerLocationId === null) throw new Error("The parameter 'customerLocationId' cannot be null.");
        else if (customerLocationId !== undefined) url_ += 'CustomerLocationId=' + encodeURIComponent('' + customerLocationId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (productCategoryId === null) throw new Error("The parameter 'productCategoryId' cannot be null.");
        else if (productCategoryId !== undefined) url_ += 'ProductCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        if (spmIdList === null) throw new Error("The parameter 'spmIdList' cannot be null.");
        else if (spmIdList !== undefined) url_ += 'SpmIdList=' + encodeURIComponent('' + spmIdList) + '&';
        if (investOwnersIdList === null) throw new Error("The parameter 'investOwnersIdList' cannot be null.");
        else if (investOwnersIdList !== undefined) url_ += 'InvestOwnersIdList=' + encodeURIComponent('' + investOwnersIdList) + '&';
        if (provisionerIdList === null) throw new Error("The parameter 'provisionerIdList' cannot be null.");
        else if (provisionerIdList !== undefined) url_ += 'ProvisionerIdList=' + encodeURIComponent('' + provisionerIdList) + '&';
        if (agentIdList === null) throw new Error("The parameter 'agentIdList' cannot be null.");
        else if (agentIdList !== undefined) url_ += 'AgentIdList=' + encodeURIComponent('' + agentIdList) + '&';
        if (orderStatusIdList === null) throw new Error("The parameter 'orderStatusIdList' cannot be null.");
        else if (orderStatusIdList !== undefined) url_ += 'OrderStatusIdList=' + encodeURIComponent('' + orderStatusIdList) + '&';
        if (contractTypeIdList === null) throw new Error("The parameter 'contractTypeIdList' cannot be null.");
        else if (contractTypeIdList !== undefined) url_ += 'ContractTypeIdList=' + encodeURIComponent('' + contractTypeIdList) + '&';
        if (ignoreCache === null) throw new Error("The parameter 'ignoreCache' cannot be null.");
        else if (ignoreCache !== undefined) url_ += 'IgnoreCache=' + encodeURIComponent('' + ignoreCache) + '&';
        if (advisorEntitlementId === null) throw new Error("The parameter 'advisorEntitlementId' cannot be null.");
        else if (advisorEntitlementId !== undefined) url_ += 'AdvisorEntitlementId=' + encodeURIComponent('' + advisorEntitlementId) + '&';
        if (salesCampaignIdList === null) throw new Error("The parameter 'salesCampaignIdList' cannot be null.");
        else if (salesCampaignIdList !== undefined) url_ += 'SalesCampaignIdList=' + encodeURIComponent('' + salesCampaignIdList) + '&';
        if (internalSalesAgentIdList === null) throw new Error("The parameter 'internalSalesAgentIdList' cannot be null.");
        else if (internalSalesAgentIdList !== undefined)
            url_ += 'InternalSalesAgentIdList=' + encodeURIComponent('' + internalSalesAgentIdList) + '&';
        if (accountManagerIdList === null) throw new Error("The parameter 'accountManagerIdList' cannot be null.");
        else if (accountManagerIdList !== undefined) url_ += 'AccountManagerIdList=' + encodeURIComponent('' + accountManagerIdList) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrdersForTableReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrdersForTableReport(<any>response_);
                        } catch (e) {
                            return <Observable<OrderListOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderListOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrdersForTableReport(response: HttpResponseBase): Observable<OrderListOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderListOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderListOutput[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updatePartnerOrderNumber(body: PartnerOrderNumberEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/UpdatePartnerOrderNumber';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdatePartnerOrderNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdatePartnerOrderNumber(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdatePartnerOrderNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    updateOrderStatus(body: OrderStatusUpdateInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/UpdateOrderStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateOrderStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateOrderStatus(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateOrderStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderLocationId (optional)
     * @return Success
     */
    getOrderLocationDetail(orderLocationId: number | undefined): Observable<OrderLocationDetailEditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderLocationDetail?';
        if (orderLocationId === null) throw new Error("The parameter 'orderLocationId' cannot be null.");
        else if (orderLocationId !== undefined) url_ += 'orderLocationId=' + encodeURIComponent('' + orderLocationId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderLocationDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderLocationDetail(<any>response_);
                        } catch (e) {
                            return <Observable<OrderLocationDetailEditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderLocationDetailEditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderLocationDetail(response: HttpResponseBase): Observable<OrderLocationDetailEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderLocationDetailEditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderLocationDetailEditDto[]>([]);
    }

    /**
     * @param orderLocationDetailId (optional)
     * @param productId (optional)
     * @return Success
     */
    validateOrderDetailAssets(orderLocationDetailId: number | undefined, productId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Order/ValidateOrderDetailAssets?';
        if (orderLocationDetailId === null) throw new Error("The parameter 'orderLocationDetailId' cannot be null.");
        else if (orderLocationDetailId !== undefined)
            url_ += 'orderLocationDetailId=' + encodeURIComponent('' + orderLocationDetailId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processValidateOrderDetailAssets(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processValidateOrderDetailAssets(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processValidateOrderDetailAssets(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getOrderLocationsDetailList(orderId: number | undefined): Observable<SendOrderDetailsOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderLocationsDetailList?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderLocationsDetailList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderLocationsDetailList(<any>response_);
                        } catch (e) {
                            return <Observable<SendOrderDetailsOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SendOrderDetailsOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderLocationsDetailList(response: HttpResponseBase): Observable<SendOrderDetailsOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SendOrderDetailsOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SendOrderDetailsOutput[]>([]);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getOrderLocationsDetailIdList(orderId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderLocationsDetailIdList?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderLocationsDetailIdList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderLocationsDetailIdList(<any>response_);
                        } catch (e) {
                            return <Observable<number[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderLocationsDetailIdList(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateOrderLocationDetailList(body: OrderLocationDetailEditDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/UpdateOrderLocationDetailList';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateOrderLocationDetailList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateOrderLocationDetailList(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateOrderLocationDetailList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteOrder(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/DeleteOrder?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteOrder(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param searchParameter (optional)
     * @return Success
     */
    getReportCommissionDateToOrders(searchParameter: string | undefined): Observable<OutputReportCommissionDateToOrder[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetReportCommissionDateToOrders?';
        if (searchParameter === null) throw new Error("The parameter 'searchParameter' cannot be null.");
        else if (searchParameter !== undefined) url_ += 'searchParameter=' + encodeURIComponent('' + searchParameter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionDateToOrders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionDateToOrders(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportCommissionDateToOrder[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportCommissionDateToOrder[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionDateToOrders(response: HttpResponseBase): Observable<OutputReportCommissionDateToOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportCommissionDateToOrder.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportCommissionDateToOrder[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrderLocationDetailCommissionMilestone(body: OrderMilestoneCreateDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Order/CreateOrderLocationDetailCommissionMilestone';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrderLocationDetailCommissionMilestone(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrderLocationDetailCommissionMilestone(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrderLocationDetailCommissionMilestone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    uploadCommissionDateOrderInput(body: OrderCommissionDateImportInput | undefined): Observable<OrderCommissionDateImportDto> {
        let url_ = this.baseUrl + '/api/services/app/Order/UploadCommissionDateOrderInput';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadCommissionDateOrderInput(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadCommissionDateOrderInput(<any>response_);
                        } catch (e) {
                            return <Observable<OrderCommissionDateImportDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderCommissionDateImportDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadCommissionDateOrderInput(response: HttpResponseBase): Observable<OrderCommissionDateImportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrderCommissionDateImportDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderCommissionDateImportDto>(<any>null);
    }

    /**
     * @param fullName (optional)
     * @param salesAgentName (optional)
     * @param orderId (optional)
     * @param orderNumber (optional)
     * @param customerName (optional)
     * @param partnerName (optional)
     * @param orderUrl (optional)
     * @return Success
     */
    getOrderEmailTemplate(
        fullName: string | undefined,
        salesAgentName: string | undefined,
        orderId: string | undefined,
        orderNumber: string | undefined,
        customerName: string | undefined,
        partnerName: string | undefined,
        orderUrl: string | undefined
    ): Observable<OrderEmailTemplateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderEmailTemplate?';
        if (fullName === null) throw new Error("The parameter 'fullName' cannot be null.");
        else if (fullName !== undefined) url_ += 'FullName=' + encodeURIComponent('' + fullName) + '&';
        if (salesAgentName === null) throw new Error("The parameter 'salesAgentName' cannot be null.");
        else if (salesAgentName !== undefined) url_ += 'SalesAgentName=' + encodeURIComponent('' + salesAgentName) + '&';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'OrderId=' + encodeURIComponent('' + orderId) + '&';
        if (orderNumber === null) throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined) url_ += 'OrderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (customerName === null) throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined) url_ += 'CustomerName=' + encodeURIComponent('' + customerName) + '&';
        if (partnerName === null) throw new Error("The parameter 'partnerName' cannot be null.");
        else if (partnerName !== undefined) url_ += 'PartnerName=' + encodeURIComponent('' + partnerName) + '&';
        if (orderUrl === null) throw new Error("The parameter 'orderUrl' cannot be null.");
        else if (orderUrl !== undefined) url_ += 'OrderUrl=' + encodeURIComponent('' + orderUrl) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderEmailTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderEmailTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<OrderEmailTemplateOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderEmailTemplateOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderEmailTemplate(response: HttpResponseBase): Observable<OrderEmailTemplateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrderEmailTemplateOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderEmailTemplateOutput>(<any>null);
    }

    /**
     * @param orderLocDetId (optional)
     * @return Success
     */
    getOrderLocationDetailStatusList(orderLocDetId: number | undefined): Observable<OrderLocationDetailStatusListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetOrderLocationDetailStatusList?';
        if (orderLocDetId === null) throw new Error("The parameter 'orderLocDetId' cannot be null.");
        else if (orderLocDetId !== undefined) url_ += 'orderLocDetId=' + encodeURIComponent('' + orderLocDetId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderLocationDetailStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderLocationDetailStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<OrderLocationDetailStatusListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderLocationDetailStatusListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderLocationDetailStatusList(response: HttpResponseBase): Observable<OrderLocationDetailStatusListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderLocationDetailStatusListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderLocationDetailStatusListDto[]>([]);
    }

    /**
     * @param spmId (optional)
     * @param pmId (optional)
     * @return Success
     */
    getPartnerManagementReport(spmId: number | undefined, pmId: number | undefined): Observable<PartnerManagementReportOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Order/GetPartnerManagementReport?';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        if (pmId === null) throw new Error("The parameter 'pmId' cannot be null.");
        else if (pmId !== undefined) url_ += 'pmId=' + encodeURIComponent('' + pmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerManagementReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerManagementReport(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerManagementReportOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerManagementReportOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerManagementReport(response: HttpResponseBase): Observable<PartnerManagementReportOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerManagementReportOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerManagementReportOutput[]>([]);
    }
}

@Injectable()
export class OrderEmailBodyBuilderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param userName (optional)
     * @return Success
     */
    withLoggedInUserName(userName: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithLoggedInUserName?';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLoggedInUserName(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLoggedInUserName(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLoggedInUserName(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param labelOrderNumber (optional)
     * @return Success
     */
    withLabelOrderNumber(labelOrderNumber: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithLabelOrderNumber?';
        if (labelOrderNumber === null) throw new Error("The parameter 'labelOrderNumber' cannot be null.");
        else if (labelOrderNumber !== undefined) url_ += 'labelOrderNumber=' + encodeURIComponent('' + labelOrderNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLabelOrderNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLabelOrderNumber(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLabelOrderNumber(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param labelSalesAgent (optional)
     * @return Success
     */
    withLabelSalesAgent(labelSalesAgent: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithLabelSalesAgent?';
        if (labelSalesAgent === null) throw new Error("The parameter 'labelSalesAgent' cannot be null.");
        else if (labelSalesAgent !== undefined) url_ += 'labelSalesAgent=' + encodeURIComponent('' + labelSalesAgent) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLabelSalesAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLabelSalesAgent(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLabelSalesAgent(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param orderNumber (optional)
     * @return Success
     */
    withOrderNumber(orderNumber: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithOrderNumber?';
        if (orderNumber === null) throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined) url_ += 'orderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithOrderNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithOrderNumber(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithOrderNumber(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    withOrderId(orderId: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithOrderId?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithOrderId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithOrderId(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithOrderId(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param customer (optional)
     * @return Success
     */
    withCustomer(customer: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithCustomer?';
        if (customer === null) throw new Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined) url_ += 'customer=' + encodeURIComponent('' + customer) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithCustomer(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param partner (optional)
     * @return Success
     */
    withPartner(partner: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithPartner?';
        if (partner === null) throw new Error("The parameter 'partner' cannot be null.");
        else if (partner !== undefined) url_ += 'partner=' + encodeURIComponent('' + partner) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithPartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithPartner(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithPartner(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param saleAgent (optional)
     * @return Success
     */
    withSalesAgent(saleAgent: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithSalesAgent?';
        if (saleAgent === null) throw new Error("The parameter 'saleAgent' cannot be null.");
        else if (saleAgent !== undefined) url_ += 'saleAgent=' + encodeURIComponent('' + saleAgent) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithSalesAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithSalesAgent(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithSalesAgent(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param viewOrderUrl (optional)
     * @return Success
     */
    withViewOrderUrl(viewOrderUrl: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithViewOrderUrl?';
        if (viewOrderUrl === null) throw new Error("The parameter 'viewOrderUrl' cannot be null.");
        else if (viewOrderUrl !== undefined) url_ += 'viewOrderUrl=' + encodeURIComponent('' + viewOrderUrl) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithViewOrderUrl(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithViewOrderUrl(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithViewOrderUrl(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withOrderLocationDetails(body: SendOrderDetailsOutput[] | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithOrderLocationDetails';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithOrderLocationDetails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithOrderLocationDetails(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithOrderLocationDetails(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withBaseTemplate(body: any | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithBaseTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithBaseTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithBaseTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithBaseTemplate(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withBodyTemplate(body: any | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithBodyTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithBodyTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithBodyTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithBodyTemplate(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param headerText (optional)
     * @return Success
     */
    withHeader(headerText: string | undefined): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithHeader?';
        if (headerText === null) throw new Error("The parameter 'headerText' cannot be null.");
        else if (headerText !== undefined) url_ += 'headerText=' + encodeURIComponent('' + headerText) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithHeader(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithHeader(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithHeader(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }

    /**
     * @param shouldThrow (optional)
     * @return Success
     */
    build(shouldThrow: boolean | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/Build?';
        if (shouldThrow === null) throw new Error("The parameter 'shouldThrow' cannot be null.");
        else if (shouldThrow !== undefined) url_ += 'shouldThrow=' + encodeURIComponent('' + shouldThrow) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processBuild(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processBuild(<any>response_);
                        } catch (e) {
                            return <Observable<any>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<any>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processBuild(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    validateBodyTemplatePlaceholders(body: any | undefined): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/ValidateBodyTemplatePlaceholders';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processValidateBodyTemplatePlaceholders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processValidateBodyTemplatePlaceholders(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processValidateBodyTemplatePlaceholders(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param title (optional)
     * @param email (optional)
     * @param phoneNumber (optional)
     * @return Success
     */
    withAssignedUserInfo(
        title: string | undefined,
        email: string | undefined,
        phoneNumber: string | undefined
    ): Observable<IOrderEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/OrderEmailBodyBuilder/WithAssignedUserInfo?';
        if (title === null) throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined) url_ += 'title=' + encodeURIComponent('' + title) + '&';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        if (phoneNumber === null) throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined) url_ += 'phoneNumber=' + encodeURIComponent('' + phoneNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithAssignedUserInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithAssignedUserInfo(<any>response_);
                        } catch (e) {
                            return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IOrderEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithAssignedUserInfo(response: HttpResponseBase): Observable<IOrderEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IOrderEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IOrderEmailBodyBuilder>(<any>null);
    }
}

@Injectable()
export class OrderSalesAgentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getOrderSalesAgents(orderId: number | undefined): Observable<OrderSalesAgentSummaryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/OrderSalesAgent/GetOrderSalesAgents?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderSalesAgents(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderSalesAgents(<any>response_);
                        } catch (e) {
                            return <Observable<OrderSalesAgentSummaryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderSalesAgentSummaryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderSalesAgents(response: HttpResponseBase): Observable<OrderSalesAgentSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderSalesAgentSummaryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderSalesAgentSummaryDto[]>([]);
    }
}

@Injectable()
export class OrderUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getOrderUsers(orderId: number | undefined): Observable<OrderUserEditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/OrderUser/GetOrderUsers?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderUsers(<any>response_);
                        } catch (e) {
                            return <Observable<OrderUserEditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrderUserEditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderUsers(response: HttpResponseBase): Observable<OrderUserEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OrderUserEditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrderUserEditDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateOrderUser(body: OrderUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrderUser/CreateOrUpdateOrderUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateOrderUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateOrderUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateOrderUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

export class ActivityPartnerSalesDashboardOutput implements IActivityPartnerSalesDashboardOutput {
    id: number;
    name: string | undefined;
    sales: number;
    base: number;
    baseAmount: number;
    orderCount: number;
    quoteCount: number;

    constructor(data?: IActivityPartnerSalesDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.sales = _data['sales'];
            this.base = _data['base'];
            this.baseAmount = _data['baseAmount'];
            this.orderCount = _data['orderCount'];
            this.quoteCount = _data['quoteCount'];
        }
    }

    static fromJS(data: any): ActivityPartnerSalesDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPartnerSalesDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['sales'] = this.sales;
        data['base'] = this.base;
        data['baseAmount'] = this.baseAmount;
        data['orderCount'] = this.orderCount;
        data['quoteCount'] = this.quoteCount;
        return data;
    }

    clone(): ActivityPartnerSalesDashboardOutput {
        const json = this.toJSON();
        let result = new ActivityPartnerSalesDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IActivityPartnerSalesDashboardOutput {
    id: number;
    name: string | undefined;
    sales: number;
    base: number;
    baseAmount: number;
    orderCount: number;
    quoteCount: number;
}

export class ContractTermListForOrderDto implements IContractTermListForOrderDto {
    contractTermId: number;

    constructor(data?: IContractTermListForOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractTermId = _data['contractTermId'];
        }
    }

    static fromJS(data: any): ContractTermListForOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTermListForOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['contractTermId'] = this.contractTermId;
        return data;
    }

    clone(): ContractTermListForOrderDto {
        const json = this.toJSON();
        let result = new ContractTermListForOrderDto();
        result.init(json);
        return result;
    }
}

export interface IContractTermListForOrderDto {
    contractTermId: number;
}

export class ContractTypeListDto implements IContractTypeListDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContractTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContractTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContractTypeListDto {
        const json = this.toJSON();
        let result = new ContractTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IContractTypeListDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomersSalesDashboardOutput implements ICustomersSalesDashboardOutput {
    description: string | undefined;
    customerId: number;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;

    constructor(data?: ICustomersSalesDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data['description'];
            this.customerId = _data['customerId'];
            this.orderCount = _data['orderCount'];
            this.mrc = _data['mrc'];
            this.nrc = _data['nrc'];
            this.total = _data['total'];
        }
    }

    static fromJS(data: any): CustomersSalesDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersSalesDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['description'] = this.description;
        data['customerId'] = this.customerId;
        data['orderCount'] = this.orderCount;
        data['mrc'] = this.mrc;
        data['nrc'] = this.nrc;
        data['total'] = this.total;
        return data;
    }

    clone(): CustomersSalesDashboardOutput {
        const json = this.toJSON();
        let result = new CustomersSalesDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ICustomersSalesDashboardOutput {
    description: string | undefined;
    customerId: number;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;
}

export class DashboardSalesOutput implements IDashboardSalesOutput {
    name: string | undefined;
    mtdSales: number;
    qtdSales: number;
    ytdSales: number;

    constructor(data?: IDashboardSalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.mtdSales = _data['mtdSales'];
            this.qtdSales = _data['qtdSales'];
            this.ytdSales = _data['ytdSales'];
        }
    }

    static fromJS(data: any): DashboardSalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['mtdSales'] = this.mtdSales;
        data['qtdSales'] = this.qtdSales;
        data['ytdSales'] = this.ytdSales;
        return data;
    }

    clone(): DashboardSalesOutput {
        const json = this.toJSON();
        let result = new DashboardSalesOutput();
        result.init(json);
        return result;
    }
}

export interface IDashboardSalesOutput {
    name: string | undefined;
    mtdSales: number;
    qtdSales: number;
    ytdSales: number;
}

export class GetActiveOrdersCountOutput implements IGetActiveOrdersCountOutput {
    activeOrderCount: number;
    sumOfMRR: number;

    constructor(data?: IGetActiveOrdersCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeOrderCount = _data['activeOrderCount'];
            this.sumOfMRR = _data['sumOfMRR'];
        }
    }

    static fromJS(data: any): GetActiveOrdersCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveOrdersCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activeOrderCount'] = this.activeOrderCount;
        data['sumOfMRR'] = this.sumOfMRR;
        return data;
    }

    clone(): GetActiveOrdersCountOutput {
        const json = this.toJSON();
        let result = new GetActiveOrdersCountOutput();
        result.init(json);
        return result;
    }
}

export interface IGetActiveOrdersCountOutput {
    activeOrderCount: number;
    sumOfMRR: number;
}

export class GetLocationListForOrderDto implements IGetLocationListForOrderDto {
    customerLocationId: number;
    productList: ProductListForOrderDto[] | undefined;
    customerLocation: CustomerLocationEditDto;

    constructor(data?: IGetLocationListForOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocationId = _data['customerLocationId'];
            if (Array.isArray(_data['productList'])) {
                this.productList = [] as any;
                for (let item of _data['productList']) this.productList.push(ProductListForOrderDto.fromJS(item));
            }
            this.customerLocation = _data['customerLocation'] ? CustomerLocationEditDto.fromJS(_data['customerLocation']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationListForOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationListForOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocationId'] = this.customerLocationId;
        if (Array.isArray(this.productList)) {
            data['productList'] = [];
            for (let item of this.productList) data['productList'].push(item.toJSON());
        }
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetLocationListForOrderDto {
        const json = this.toJSON();
        let result = new GetLocationListForOrderDto();
        result.init(json);
        return result;
    }
}

export interface IGetLocationListForOrderDto {
    customerLocationId: number;
    productList: ProductListForOrderDto[] | undefined;
    customerLocation: CustomerLocationEditDto;
}

export class IOrderEmailBodyBuilder implements IIOrderEmailBodyBuilder {
    constructor(data?: IIOrderEmailBodyBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): IOrderEmailBodyBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderEmailBodyBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IOrderEmailBodyBuilder {
        const json = this.toJSON();
        let result = new IOrderEmailBodyBuilder();
        result.init(json);
        return result;
    }
}

export interface IIOrderEmailBodyBuilder {}

export class MilestoneEditDto implements IMilestoneEditDto {
    id: number | undefined;
    name: string | undefined;
    isRequired: boolean;
    requiresNotification: boolean;
    notifyOnUpdate: boolean;
    order: number;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    surveyId: number | undefined;

    constructor(data?: IMilestoneEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.isRequired = _data['isRequired'];
            this.requiresNotification = _data['requiresNotification'];
            this.notifyOnUpdate = _data['notifyOnUpdate'];
            this.order = _data['order'];
            this.notifyFrom = _data['notifyFrom'];
            this.notifySubject = _data['notifySubject'];
            this.notifyTemplate = _data['notifyTemplate'];
            this.surveyId = _data['surveyId'];
        }
    }

    static fromJS(data: any): MilestoneEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['isRequired'] = this.isRequired;
        data['requiresNotification'] = this.requiresNotification;
        data['notifyOnUpdate'] = this.notifyOnUpdate;
        data['order'] = this.order;
        data['notifyFrom'] = this.notifyFrom;
        data['notifySubject'] = this.notifySubject;
        data['notifyTemplate'] = this.notifyTemplate;
        data['surveyId'] = this.surveyId;
        return data;
    }

    clone(): MilestoneEditDto {
        const json = this.toJSON();
        let result = new MilestoneEditDto();
        result.init(json);
        return result;
    }
}

export interface IMilestoneEditDto {
    id: number | undefined;
    name: string | undefined;
    isRequired: boolean;
    requiresNotification: boolean;
    notifyOnUpdate: boolean;
    order: number;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    surveyId: number | undefined;
}

export class OpenOrdersAgingDashboardOutput implements IOpenOrdersAgingDashboardOutput {
    name: string | undefined;
    two: number;
    four: number;
    ten: number;
    twenty: number;
    thirty: number;
    sixty: number;
    ninety: number;
    oneTwenty: number;
    oneTwentyPlus: number;

    constructor(data?: IOpenOrdersAgingDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.two = _data['two'];
            this.four = _data['four'];
            this.ten = _data['ten'];
            this.twenty = _data['twenty'];
            this.thirty = _data['thirty'];
            this.sixty = _data['sixty'];
            this.ninety = _data['ninety'];
            this.oneTwenty = _data['oneTwenty'];
            this.oneTwentyPlus = _data['oneTwentyPlus'];
        }
    }

    static fromJS(data: any): OpenOrdersAgingDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OpenOrdersAgingDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['two'] = this.two;
        data['four'] = this.four;
        data['ten'] = this.ten;
        data['twenty'] = this.twenty;
        data['thirty'] = this.thirty;
        data['sixty'] = this.sixty;
        data['ninety'] = this.ninety;
        data['oneTwenty'] = this.oneTwenty;
        data['oneTwentyPlus'] = this.oneTwentyPlus;
        return data;
    }

    clone(): OpenOrdersAgingDashboardOutput {
        const json = this.toJSON();
        let result = new OpenOrdersAgingDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IOpenOrdersAgingDashboardOutput {
    name: string | undefined;
    two: number;
    four: number;
    ten: number;
    twenty: number;
    thirty: number;
    sixty: number;
    ninety: number;
    oneTwenty: number;
    oneTwentyPlus: number;
}

export class OpenOrdersDashboardOutput implements IOpenOrdersDashboardOutput {
    orderId: number;
    partnerOrderNumber: string | undefined;
    customer: string | undefined;
    location: string | undefined;
    salesAgent: string | undefined;
    status: string | undefined;
    statusAging: number;
    provisioner: string | undefined;
    provider: string | undefined;
    product: string | undefined;
    mrr: number;
    orderNumber: string | undefined;
    received: moment.Moment;

    constructor(data?: IOpenOrdersDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.customer = _data['customer'];
            this.location = _data['location'];
            this.salesAgent = _data['salesAgent'];
            this.status = _data['status'];
            this.statusAging = _data['statusAging'];
            this.provisioner = _data['provisioner'];
            this.provider = _data['provider'];
            this.product = _data['product'];
            this.mrr = _data['mrr'];
            this.orderNumber = _data['orderNumber'];
            this.received = _data['received'] ? moment(_data['received'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OpenOrdersDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OpenOrdersDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['customer'] = this.customer;
        data['location'] = this.location;
        data['salesAgent'] = this.salesAgent;
        data['status'] = this.status;
        data['statusAging'] = this.statusAging;
        data['provisioner'] = this.provisioner;
        data['provider'] = this.provider;
        data['product'] = this.product;
        data['mrr'] = this.mrr;
        data['orderNumber'] = this.orderNumber;
        data['received'] = this.received ? this.received.toISOString() : <any>undefined;
        return data;
    }

    clone(): OpenOrdersDashboardOutput {
        const json = this.toJSON();
        let result = new OpenOrdersDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IOpenOrdersDashboardOutput {
    orderId: number;
    partnerOrderNumber: string | undefined;
    customer: string | undefined;
    location: string | undefined;
    salesAgent: string | undefined;
    status: string | undefined;
    statusAging: number;
    provisioner: string | undefined;
    provider: string | undefined;
    product: string | undefined;
    mrr: number;
    orderNumber: string | undefined;
    received: moment.Moment;
}

export class OrderCommissionDateImportDto implements IOrderCommissionDateImportDto {
    invalidColumnList: string[] | undefined;
    invalidRowList: string[] | undefined;
    invalidFlag: boolean;

    constructor(data?: IOrderCommissionDateImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['invalidColumnList'])) {
                this.invalidColumnList = [] as any;
                for (let item of _data['invalidColumnList']) this.invalidColumnList.push(item);
            }
            if (Array.isArray(_data['invalidRowList'])) {
                this.invalidRowList = [] as any;
                for (let item of _data['invalidRowList']) this.invalidRowList.push(item);
            }
            this.invalidFlag = _data['invalidFlag'];
        }
    }

    static fromJS(data: any): OrderCommissionDateImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCommissionDateImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invalidColumnList)) {
            data['invalidColumnList'] = [];
            for (let item of this.invalidColumnList) data['invalidColumnList'].push(item);
        }
        if (Array.isArray(this.invalidRowList)) {
            data['invalidRowList'] = [];
            for (let item of this.invalidRowList) data['invalidRowList'].push(item);
        }
        data['invalidFlag'] = this.invalidFlag;
        return data;
    }

    clone(): OrderCommissionDateImportDto {
        const json = this.toJSON();
        let result = new OrderCommissionDateImportDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCommissionDateImportDto {
    invalidColumnList: string[] | undefined;
    invalidRowList: string[] | undefined;
    invalidFlag: boolean;
}

export class OrderCommissionDateImportInput implements IOrderCommissionDateImportInput {
    fileName: string;

    constructor(data?: IOrderCommissionDateImportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
        }
    }

    static fromJS(data: any): OrderCommissionDateImportInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCommissionDateImportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        return data;
    }

    clone(): OrderCommissionDateImportInput {
        const json = this.toJSON();
        let result = new OrderCommissionDateImportInput();
        result.init(json);
        return result;
    }
}

export interface IOrderCommissionDateImportInput {
    fileName: string;
}

export class OrderDetailsListDto implements IOrderDetailsListDto {
    orderId: number;
    customerId: number;
    partnerId: number;
    salesAgentId: number;
    specialRateStatus: boolean;
    createAttribJson: string | undefined;
    salesCampaignId: number | undefined;
    internalSalesAgentId: number | undefined;
    customerLocationList: GetLocationListForOrderDto[] | undefined;
    contractTermList: ContractTermListForOrderDto[] | undefined;
    orderSalesAgents: OrderSalesAgentDto[] | undefined;
    id: number;

    constructor(data?: IOrderDetailsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.customerId = _data['customerId'];
            this.partnerId = _data['partnerId'];
            this.salesAgentId = _data['salesAgentId'];
            this.specialRateStatus = _data['specialRateStatus'];
            this.createAttribJson = _data['createAttribJson'];
            this.salesCampaignId = _data['salesCampaignId'];
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            if (Array.isArray(_data['customerLocationList'])) {
                this.customerLocationList = [] as any;
                for (let item of _data['customerLocationList']) this.customerLocationList.push(GetLocationListForOrderDto.fromJS(item));
            }
            if (Array.isArray(_data['contractTermList'])) {
                this.contractTermList = [] as any;
                for (let item of _data['contractTermList']) this.contractTermList.push(ContractTermListForOrderDto.fromJS(item));
            }
            if (Array.isArray(_data['orderSalesAgents'])) {
                this.orderSalesAgents = [] as any;
                for (let item of _data['orderSalesAgents']) this.orderSalesAgents.push(OrderSalesAgentDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderDetailsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['customerId'] = this.customerId;
        data['partnerId'] = this.partnerId;
        data['salesAgentId'] = this.salesAgentId;
        data['specialRateStatus'] = this.specialRateStatus;
        data['createAttribJson'] = this.createAttribJson;
        data['salesCampaignId'] = this.salesCampaignId;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        if (Array.isArray(this.customerLocationList)) {
            data['customerLocationList'] = [];
            for (let item of this.customerLocationList) data['customerLocationList'].push(item.toJSON());
        }
        if (Array.isArray(this.contractTermList)) {
            data['contractTermList'] = [];
            for (let item of this.contractTermList) data['contractTermList'].push(item.toJSON());
        }
        if (Array.isArray(this.orderSalesAgents)) {
            data['orderSalesAgents'] = [];
            for (let item of this.orderSalesAgents) data['orderSalesAgents'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): OrderDetailsListDto {
        const json = this.toJSON();
        let result = new OrderDetailsListDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailsListDto {
    orderId: number;
    customerId: number;
    partnerId: number;
    salesAgentId: number;
    specialRateStatus: boolean;
    createAttribJson: string | undefined;
    salesCampaignId: number | undefined;
    internalSalesAgentId: number | undefined;
    customerLocationList: GetLocationListForOrderDto[] | undefined;
    contractTermList: ContractTermListForOrderDto[] | undefined;
    orderSalesAgents: OrderSalesAgentDto[] | undefined;
    id: number;
}

export class OrderEditDto implements IOrderEditDto {
    tenantId: number | undefined;
    orderNumber: string;
    customerId: number;
    customer: CustomerEditDto;
    partnerId: number;
    partner: PartnerEditDto;
    orderStage: OrderStage;
    salesAgentId: number;
    salesAgent: UserListDto;
    orderSalesAgents: OrderSalesAgentDto[] | undefined;
    salesEngineerId: number | undefined;
    salesEngineer: UserListDto;
    createAttribJson: string | undefined;
    quoteId: number | undefined;
    specialRateStatus: boolean;
    isSpecialRateStatusReadonly: boolean;
    specialRateLockedDate: moment.Moment | undefined;
    salesCampaignId: number | undefined;
    internalSalesAgentId: number | undefined;
    orderUsers: OrderUserEditDto[] | undefined;
    orderLocations: OrderLocationEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderNumber = _data['orderNumber'];
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnerEditDto.fromJS(_data['partner']) : <any>undefined;
            this.orderStage = _data['orderStage'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? UserListDto.fromJS(_data['salesAgent']) : <any>undefined;
            if (Array.isArray(_data['orderSalesAgents'])) {
                this.orderSalesAgents = [] as any;
                for (let item of _data['orderSalesAgents']) this.orderSalesAgents.push(OrderSalesAgentDto.fromJS(item));
            }
            this.salesEngineerId = _data['salesEngineerId'];
            this.salesEngineer = _data['salesEngineer'] ? UserListDto.fromJS(_data['salesEngineer']) : <any>undefined;
            this.createAttribJson = _data['createAttribJson'];
            this.quoteId = _data['quoteId'];
            this.specialRateStatus = _data['specialRateStatus'];
            this.isSpecialRateStatusReadonly = _data['isSpecialRateStatusReadonly'];
            this.specialRateLockedDate = _data['specialRateLockedDate']
                ? moment(_data['specialRateLockedDate'].toString())
                : <any>undefined;
            this.salesCampaignId = _data['salesCampaignId'];
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            if (Array.isArray(_data['orderUsers'])) {
                this.orderUsers = [] as any;
                for (let item of _data['orderUsers']) this.orderUsers.push(OrderUserEditDto.fromJS(item));
            }
            if (Array.isArray(_data['orderLocations'])) {
                this.orderLocations = [] as any;
                for (let item of _data['orderLocations']) this.orderLocations.push(OrderLocationEditDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderNumber'] = this.orderNumber;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['orderStage'] = this.orderStage;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        if (Array.isArray(this.orderSalesAgents)) {
            data['orderSalesAgents'] = [];
            for (let item of this.orderSalesAgents) data['orderSalesAgents'].push(item.toJSON());
        }
        data['salesEngineerId'] = this.salesEngineerId;
        data['salesEngineer'] = this.salesEngineer ? this.salesEngineer.toJSON() : <any>undefined;
        data['createAttribJson'] = this.createAttribJson;
        data['quoteId'] = this.quoteId;
        data['specialRateStatus'] = this.specialRateStatus;
        data['isSpecialRateStatusReadonly'] = this.isSpecialRateStatusReadonly;
        data['specialRateLockedDate'] = this.specialRateLockedDate ? this.specialRateLockedDate.toISOString() : <any>undefined;
        data['salesCampaignId'] = this.salesCampaignId;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        if (Array.isArray(this.orderUsers)) {
            data['orderUsers'] = [];
            for (let item of this.orderUsers) data['orderUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocations)) {
            data['orderLocations'] = [];
            for (let item of this.orderLocations) data['orderLocations'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderEditDto {
        const json = this.toJSON();
        let result = new OrderEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderEditDto {
    tenantId: number | undefined;
    orderNumber: string;
    customerId: number;
    customer: CustomerEditDto;
    partnerId: number;
    partner: PartnerEditDto;
    orderStage: OrderStage;
    salesAgentId: number;
    salesAgent: UserListDto;
    orderSalesAgents: OrderSalesAgentDto[] | undefined;
    salesEngineerId: number | undefined;
    salesEngineer: UserListDto;
    createAttribJson: string | undefined;
    quoteId: number | undefined;
    specialRateStatus: boolean;
    isSpecialRateStatusReadonly: boolean;
    specialRateLockedDate: moment.Moment | undefined;
    salesCampaignId: number | undefined;
    internalSalesAgentId: number | undefined;
    orderUsers: OrderUserEditDto[] | undefined;
    orderLocations: OrderLocationEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderEmailTemplateOutput implements IOrderEmailTemplateOutput {
    emailTemplate: string | undefined;

    constructor(data?: IOrderEmailTemplateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplate = _data['emailTemplate'];
        }
    }

    static fromJS(data: any): OrderEmailTemplateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEmailTemplateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailTemplate'] = this.emailTemplate;
        return data;
    }

    clone(): OrderEmailTemplateOutput {
        const json = this.toJSON();
        let result = new OrderEmailTemplateOutput();
        result.init(json);
        return result;
    }
}

export interface IOrderEmailTemplateOutput {
    emailTemplate: string | undefined;
}

export class OrderInquiryTicketDto implements IOrderInquiryTicketDto {
    orderId: number;
    orderNumber: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    customerId: number;
    customerName: string | undefined;
    salesAgentName: string | undefined;
    additionalSalesAgentNames: string[] | undefined;
    locations: OrderInquiryTicketOrderLocationDto[] | undefined;
    uniqueProviderIds: number[] | undefined;

    constructor(data?: IOrderInquiryTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.salesAgentName = _data['salesAgentName'];
            if (Array.isArray(_data['additionalSalesAgentNames'])) {
                this.additionalSalesAgentNames = [] as any;
                for (let item of _data['additionalSalesAgentNames']) this.additionalSalesAgentNames.push(item);
            }
            if (Array.isArray(_data['locations'])) {
                this.locations = [] as any;
                for (let item of _data['locations']) this.locations.push(OrderInquiryTicketOrderLocationDto.fromJS(item));
            }
            if (Array.isArray(_data['uniqueProviderIds'])) {
                this.uniqueProviderIds = [] as any;
                for (let item of _data['uniqueProviderIds']) this.uniqueProviderIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderInquiryTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInquiryTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['salesAgentName'] = this.salesAgentName;
        if (Array.isArray(this.additionalSalesAgentNames)) {
            data['additionalSalesAgentNames'] = [];
            for (let item of this.additionalSalesAgentNames) data['additionalSalesAgentNames'].push(item);
        }
        if (Array.isArray(this.locations)) {
            data['locations'] = [];
            for (let item of this.locations) data['locations'].push(item.toJSON());
        }
        if (Array.isArray(this.uniqueProviderIds)) {
            data['uniqueProviderIds'] = [];
            for (let item of this.uniqueProviderIds) data['uniqueProviderIds'].push(item);
        }
        return data;
    }

    clone(): OrderInquiryTicketDto {
        const json = this.toJSON();
        let result = new OrderInquiryTicketDto();
        result.init(json);
        return result;
    }
}

export interface IOrderInquiryTicketDto {
    orderId: number;
    orderNumber: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    customerId: number;
    customerName: string | undefined;
    salesAgentName: string | undefined;
    additionalSalesAgentNames: string[] | undefined;
    locations: OrderInquiryTicketOrderLocationDto[] | undefined;
    uniqueProviderIds: number[] | undefined;
}

export class OrderInquiryTicketOrderLocationDetailDto implements IOrderInquiryTicketOrderLocationDetailDto {
    productName: string | undefined;
    providerName: string | undefined;

    constructor(data?: IOrderInquiryTicketOrderLocationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data['productName'];
            this.providerName = _data['providerName'];
        }
    }

    static fromJS(data: any): OrderInquiryTicketOrderLocationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInquiryTicketOrderLocationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productName'] = this.productName;
        data['providerName'] = this.providerName;
        return data;
    }

    clone(): OrderInquiryTicketOrderLocationDetailDto {
        const json = this.toJSON();
        let result = new OrderInquiryTicketOrderLocationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderInquiryTicketOrderLocationDetailDto {
    productName: string | undefined;
    providerName: string | undefined;
}

export class OrderInquiryTicketOrderLocationDto implements IOrderInquiryTicketOrderLocationDto {
    address: string | undefined;
    services: OrderInquiryTicketOrderLocationDetailDto[] | undefined;

    constructor(data?: IOrderInquiryTicketOrderLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data['address'];
            if (Array.isArray(_data['services'])) {
                this.services = [] as any;
                for (let item of _data['services']) this.services.push(OrderInquiryTicketOrderLocationDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderInquiryTicketOrderLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInquiryTicketOrderLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['address'] = this.address;
        if (Array.isArray(this.services)) {
            data['services'] = [];
            for (let item of this.services) data['services'].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderInquiryTicketOrderLocationDto {
        const json = this.toJSON();
        let result = new OrderInquiryTicketOrderLocationDto();
        result.init(json);
        return result;
    }
}

export interface IOrderInquiryTicketOrderLocationDto {
    address: string | undefined;
    services: OrderInquiryTicketOrderLocationDetailDto[] | undefined;
}

export class OrderListOutput implements IOrderListOutput {
    orderId: number;
    orderLocationDetailId: number;
    partnerId: number;
    apid: number | undefined;
    partner: string | undefined;
    salesAgent: string | undefined;
    orderNumber: string | undefined;
    billingAccountNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    providerOrderNumber: string | undefined;
    assignedProvisoner: string | undefined;
    spm: string | undefined;
    customer: string | undefined;
    location: string | undefined;
    product: string | undefined;
    provider: string | undefined;
    mrc: number | undefined;
    nrc: number | undefined;
    orderStatus: string | undefined;
    orderReceived: moment.Moment | undefined;
    milestoneName: string | undefined;
    milestoneDaysOld: number;
    contractType: string | undefined;
    salesCampaignName: string | undefined;
    internalSalesAgentName: string | undefined;
    accountManagerName: string | undefined;

    constructor(data?: IOrderListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.partnerId = _data['partnerId'];
            this.apid = _data['apid'];
            this.partner = _data['partner'];
            this.salesAgent = _data['salesAgent'];
            this.orderNumber = _data['orderNumber'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.providerOrderNumber = _data['providerOrderNumber'];
            this.assignedProvisoner = _data['assignedProvisoner'];
            this.spm = _data['spm'];
            this.customer = _data['customer'];
            this.location = _data['location'];
            this.product = _data['product'];
            this.provider = _data['provider'];
            this.mrc = _data['mrc'];
            this.nrc = _data['nrc'];
            this.orderStatus = _data['orderStatus'];
            this.orderReceived = _data['orderReceived'] ? moment(_data['orderReceived'].toString()) : <any>undefined;
            this.milestoneName = _data['milestoneName'];
            this.milestoneDaysOld = _data['milestoneDaysOld'];
            this.contractType = _data['contractType'];
            this.salesCampaignName = _data['salesCampaignName'];
            this.internalSalesAgentName = _data['internalSalesAgentName'];
            this.accountManagerName = _data['accountManagerName'];
        }
    }

    static fromJS(data: any): OrderListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['partnerId'] = this.partnerId;
        data['apid'] = this.apid;
        data['partner'] = this.partner;
        data['salesAgent'] = this.salesAgent;
        data['orderNumber'] = this.orderNumber;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['providerOrderNumber'] = this.providerOrderNumber;
        data['assignedProvisoner'] = this.assignedProvisoner;
        data['spm'] = this.spm;
        data['customer'] = this.customer;
        data['location'] = this.location;
        data['product'] = this.product;
        data['provider'] = this.provider;
        data['mrc'] = this.mrc;
        data['nrc'] = this.nrc;
        data['orderStatus'] = this.orderStatus;
        data['orderReceived'] = this.orderReceived ? this.orderReceived.toISOString() : <any>undefined;
        data['milestoneName'] = this.milestoneName;
        data['milestoneDaysOld'] = this.milestoneDaysOld;
        data['contractType'] = this.contractType;
        data['salesCampaignName'] = this.salesCampaignName;
        data['internalSalesAgentName'] = this.internalSalesAgentName;
        data['accountManagerName'] = this.accountManagerName;
        return data;
    }

    clone(): OrderListOutput {
        const json = this.toJSON();
        let result = new OrderListOutput();
        result.init(json);
        return result;
    }
}

export interface IOrderListOutput {
    orderId: number;
    orderLocationDetailId: number;
    partnerId: number;
    apid: number | undefined;
    partner: string | undefined;
    salesAgent: string | undefined;
    orderNumber: string | undefined;
    billingAccountNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    providerOrderNumber: string | undefined;
    assignedProvisoner: string | undefined;
    spm: string | undefined;
    customer: string | undefined;
    location: string | undefined;
    product: string | undefined;
    provider: string | undefined;
    mrc: number | undefined;
    nrc: number | undefined;
    orderStatus: string | undefined;
    orderReceived: moment.Moment | undefined;
    milestoneName: string | undefined;
    milestoneDaysOld: number;
    contractType: string | undefined;
    salesCampaignName: string | undefined;
    internalSalesAgentName: string | undefined;
    accountManagerName: string | undefined;
}

export class OrderListTotals implements IOrderListTotals {
    totalCount: number;
    totalAmount: number;

    constructor(data?: IOrderListTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            this.totalAmount = _data['totalAmount'];
        }
    }

    static fromJS(data: any): OrderListTotals {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        data['totalAmount'] = this.totalAmount;
        return data;
    }

    clone(): OrderListTotals {
        const json = this.toJSON();
        let result = new OrderListTotals();
        result.init(json);
        return result;
    }
}

export interface IOrderListTotals {
    totalCount: number;
    totalAmount: number;
}

export class OrderLocationDetailContractEditDto implements IOrderLocationDetailContractEditDto {
    orderLocationDetailId: number;
    contractTermId: number;
    contractTerm: ContractTermListDto;
    contractTypeId: number;
    contractType: ContractTypeListDto;
    contractSigned: moment.Moment | undefined;
    contractStart: moment.Moment | undefined;
    contractEnd: moment.Moment | undefined;
    mrr: number | undefined;
    nrr: number | undefined;
    salesCommissionAdj: number | undefined;
    productCode: string | undefined;
    providerQuoteNumber: string | undefined;
    providerContractNumber: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailContractEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.contractTermId = _data['contractTermId'];
            this.contractTerm = _data['contractTerm'] ? ContractTermListDto.fromJS(_data['contractTerm']) : <any>undefined;
            this.contractTypeId = _data['contractTypeId'];
            this.contractType = _data['contractType'] ? ContractTypeListDto.fromJS(_data['contractType']) : <any>undefined;
            this.contractSigned = _data['contractSigned'] ? moment(_data['contractSigned'].toString()) : <any>undefined;
            this.contractStart = _data['contractStart'] ? moment(_data['contractStart'].toString()) : <any>undefined;
            this.contractEnd = _data['contractEnd'] ? moment(_data['contractEnd'].toString()) : <any>undefined;
            this.mrr = _data['mrr'];
            this.nrr = _data['nrr'];
            this.salesCommissionAdj = _data['salesCommissionAdj'];
            this.productCode = _data['productCode'];
            this.providerQuoteNumber = _data['providerQuoteNumber'];
            this.providerContractNumber = _data['providerContractNumber'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailContractEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailContractEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['contractTermId'] = this.contractTermId;
        data['contractTerm'] = this.contractTerm ? this.contractTerm.toJSON() : <any>undefined;
        data['contractTypeId'] = this.contractTypeId;
        data['contractType'] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data['contractSigned'] = this.contractSigned ? this.contractSigned.toISOString() : <any>undefined;
        data['contractStart'] = this.contractStart ? this.contractStart.toISOString() : <any>undefined;
        data['contractEnd'] = this.contractEnd ? this.contractEnd.toISOString() : <any>undefined;
        data['mrr'] = this.mrr;
        data['nrr'] = this.nrr;
        data['salesCommissionAdj'] = this.salesCommissionAdj;
        data['productCode'] = this.productCode;
        data['providerQuoteNumber'] = this.providerQuoteNumber;
        data['providerContractNumber'] = this.providerContractNumber;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailContractEditDto {
        const json = this.toJSON();
        let result = new OrderLocationDetailContractEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailContractEditDto {
    orderLocationDetailId: number;
    contractTermId: number;
    contractTerm: ContractTermListDto;
    contractTypeId: number;
    contractType: ContractTypeListDto;
    contractSigned: moment.Moment | undefined;
    contractStart: moment.Moment | undefined;
    contractEnd: moment.Moment | undefined;
    mrr: number | undefined;
    nrr: number | undefined;
    salesCommissionAdj: number | undefined;
    productCode: string | undefined;
    providerQuoteNumber: string | undefined;
    providerContractNumber: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailEditDto implements IOrderLocationDetailEditDto {
    tenantId: number | undefined;
    orderLocationId: number;
    productId: number;
    product: ProductEditDto;
    providerId: number;
    provider: ProviderEditDto;
    quoteDetailId: number;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    requestedProvisionDate: moment.Moment | undefined;
    orderStatusDate: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    corporateAccountNumber: string | undefined;
    providerOrderNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    orderLocationDetailMilestones: OrderLocationDetailMilestoneEditDto[] | undefined;
    orderLocationDetailContracts: OrderLocationDetailContractEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationId = _data['orderLocationId'];
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductEditDto.fromJS(_data['product']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.quoteDetailId = _data['quoteDetailId'];
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatus = _data['orderStatus'] ? OrderStatusEditDto.fromJS(_data['orderStatus']) : <any>undefined;
            this.requestedProvisionDate = _data['requestedProvisionDate']
                ? moment(_data['requestedProvisionDate'].toString())
                : <any>undefined;
            this.orderStatusDate = _data['orderStatusDate'] ? moment(_data['orderStatusDate'].toString()) : <any>undefined;
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.corporateAccountNumber = _data['corporateAccountNumber'];
            this.providerOrderNumber = _data['providerOrderNumber'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            if (Array.isArray(_data['orderLocationDetailMilestones'])) {
                this.orderLocationDetailMilestones = [] as any;
                for (let item of _data['orderLocationDetailMilestones'])
                    this.orderLocationDetailMilestones.push(OrderLocationDetailMilestoneEditDto.fromJS(item));
            }
            if (Array.isArray(_data['orderLocationDetailContracts'])) {
                this.orderLocationDetailContracts = [] as any;
                for (let item of _data['orderLocationDetailContracts'])
                    this.orderLocationDetailContracts.push(OrderLocationDetailContractEditDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationId'] = this.orderLocationId;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['quoteDetailId'] = this.quoteDetailId;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatus'] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data['requestedProvisionDate'] = this.requestedProvisionDate ? this.requestedProvisionDate.toISOString() : <any>undefined;
        data['orderStatusDate'] = this.orderStatusDate ? this.orderStatusDate.toISOString() : <any>undefined;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['corporateAccountNumber'] = this.corporateAccountNumber;
        data['providerOrderNumber'] = this.providerOrderNumber;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        if (Array.isArray(this.orderLocationDetailMilestones)) {
            data['orderLocationDetailMilestones'] = [];
            for (let item of this.orderLocationDetailMilestones) data['orderLocationDetailMilestones'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocationDetailContracts)) {
            data['orderLocationDetailContracts'] = [];
            for (let item of this.orderLocationDetailContracts) data['orderLocationDetailContracts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailEditDto {
        const json = this.toJSON();
        let result = new OrderLocationDetailEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailEditDto {
    tenantId: number | undefined;
    orderLocationId: number;
    productId: number;
    product: ProductEditDto;
    providerId: number;
    provider: ProviderEditDto;
    quoteDetailId: number;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    requestedProvisionDate: moment.Moment | undefined;
    orderStatusDate: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    corporateAccountNumber: string | undefined;
    providerOrderNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    orderLocationDetailMilestones: OrderLocationDetailMilestoneEditDto[] | undefined;
    orderLocationDetailContracts: OrderLocationDetailContractEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailMilestoneEditDto implements IOrderLocationDetailMilestoneEditDto {
    orderLocationDetailId: number;
    productMilestoneId: number;
    productMilestone: ProductMilestoneEditDto;
    value: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailMilestoneEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.productMilestoneId = _data['productMilestoneId'];
            this.productMilestone = _data['productMilestone'] ? ProductMilestoneEditDto.fromJS(_data['productMilestone']) : <any>undefined;
            this.value = _data['value'] ? moment(_data['value'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailMilestoneEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailMilestoneEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['productMilestoneId'] = this.productMilestoneId;
        data['productMilestone'] = this.productMilestone ? this.productMilestone.toJSON() : <any>undefined;
        data['value'] = this.value ? this.value.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailMilestoneEditDto {
        const json = this.toJSON();
        let result = new OrderLocationDetailMilestoneEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailMilestoneEditDto {
    orderLocationDetailId: number;
    productMilestoneId: number;
    productMilestone: ProductMilestoneEditDto;
    value: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailStatusListDto implements IOrderLocationDetailStatusListDto {
    orderLocationDetailId: number;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    id: number;

    constructor(data?: IOrderLocationDetailStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatus = _data['orderStatus'] ? OrderStatusEditDto.fromJS(_data['orderStatus']) : <any>undefined;
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailStatusListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatus'] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailStatusListDto {
        const json = this.toJSON();
        let result = new OrderLocationDetailStatusListDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailStatusListDto {
    orderLocationDetailId: number;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    id: number;
}

export class OrderLocationDetailViewDto implements IOrderLocationDetailViewDto {
    productId: number;
    product: ProductEditDto;
    providerId: number;
    provider: ProviderEditDto;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductEditDto.fromJS(_data['product']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatus = _data['orderStatus'] ? OrderStatusEditDto.fromJS(_data['orderStatus']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatus'] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailViewDto {
        const json = this.toJSON();
        let result = new OrderLocationDetailViewDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailViewDto {
    productId: number;
    product: ProductEditDto;
    providerId: number;
    provider: ProviderEditDto;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationEditDto implements IOrderLocationEditDto {
    tenantId: number | undefined;
    orderId: number;
    customerLocationId: number;
    customerLocation: CustomerLocationEditDto;
    orderLocationDetails: OrderLocationDetailEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationEditDto.fromJS(_data['customerLocation']) : <any>undefined;
            if (Array.isArray(_data['orderLocationDetails'])) {
                this.orderLocationDetails = [] as any;
                for (let item of _data['orderLocationDetails']) this.orderLocationDetails.push(OrderLocationDetailEditDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLocationDetails)) {
            data['orderLocationDetails'] = [];
            for (let item of this.orderLocationDetails) data['orderLocationDetails'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationEditDto {
        const json = this.toJSON();
        let result = new OrderLocationEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationEditDto {
    tenantId: number | undefined;
    orderId: number;
    customerLocationId: number;
    customerLocation: CustomerLocationEditDto;
    orderLocationDetails: OrderLocationDetailEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationViewDto implements IOrderLocationViewDto {
    tenantId: number | undefined;
    orderId: number;
    customerLocationId: number;
    customerLocation: CustomerLocationEditDto;
    orderLocationDetails: OrderLocationDetailViewDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationEditDto.fromJS(_data['customerLocation']) : <any>undefined;
            if (Array.isArray(_data['orderLocationDetails'])) {
                this.orderLocationDetails = [] as any;
                for (let item of _data['orderLocationDetails']) this.orderLocationDetails.push(OrderLocationDetailViewDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLocationDetails)) {
            data['orderLocationDetails'] = [];
            for (let item of this.orderLocationDetails) data['orderLocationDetails'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationViewDto {
        const json = this.toJSON();
        let result = new OrderLocationViewDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationViewDto {
    tenantId: number | undefined;
    orderId: number;
    customerLocationId: number;
    customerLocation: CustomerLocationEditDto;
    orderLocationDetails: OrderLocationDetailViewDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderMilestoneCreateDto implements IOrderMilestoneCreateDto {
    orderNumber: string | undefined;
    value: string | undefined;
    providerId: number;

    constructor(data?: IOrderMilestoneCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data['orderNumber'];
            this.value = _data['value'];
            this.providerId = _data['providerId'];
        }
    }

    static fromJS(data: any): OrderMilestoneCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderMilestoneCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderNumber'] = this.orderNumber;
        data['value'] = this.value;
        data['providerId'] = this.providerId;
        return data;
    }

    clone(): OrderMilestoneCreateDto {
        const json = this.toJSON();
        let result = new OrderMilestoneCreateDto();
        result.init(json);
        return result;
    }
}

export interface IOrderMilestoneCreateDto {
    orderNumber: string | undefined;
    value: string | undefined;
    providerId: number;
}

export class OrderSalesAgentDto implements IOrderSalesAgentDto {
    orderId: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentId: number;
    salesAgentName: string | undefined;
    splitRate: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IOrderSalesAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgentName = _data['salesAgentName'];
            this.splitRate = _data['splitRate'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderSalesAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSalesAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgentName'] = this.salesAgentName;
        data['splitRate'] = this.splitRate;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderSalesAgentDto {
        const json = this.toJSON();
        let result = new OrderSalesAgentDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSalesAgentDto {
    orderId: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentId: number;
    salesAgentName: string | undefined;
    splitRate: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class OrderSalesAgentSummaryDto implements IOrderSalesAgentSummaryDto {
    isPrimary: boolean;
    orderId: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentId: number;
    salesAgentName: string | undefined;
    splitRate: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IOrderSalesAgentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data['isPrimary'];
            this.orderId = _data['orderId'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgentName = _data['salesAgentName'];
            this.splitRate = _data['splitRate'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderSalesAgentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSalesAgentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isPrimary'] = this.isPrimary;
        data['orderId'] = this.orderId;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgentName'] = this.salesAgentName;
        data['splitRate'] = this.splitRate;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderSalesAgentSummaryDto {
        const json = this.toJSON();
        let result = new OrderSalesAgentSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSalesAgentSummaryDto {
    isPrimary: boolean;
    orderId: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentId: number;
    salesAgentName: string | undefined;
    splitRate: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export enum OrderStage {
    _0 = 0,
    _1 = 1,
}

export class OrderStatusEditDto implements IOrderStatusEditDto {
    tenantId: number | undefined;
    name: string | undefined;
    type: number;
    order: number;
    requiresNotification: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderStatusEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.type = _data['type'];
            this.order = _data['order'];
            this.requiresNotification = _data['requiresNotification'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderStatusEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['type'] = this.type;
        data['order'] = this.order;
        data['requiresNotification'] = this.requiresNotification;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderStatusEditDto {
        const json = this.toJSON();
        let result = new OrderStatusEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStatusEditDto {
    tenantId: number | undefined;
    name: string | undefined;
    type: number;
    order: number;
    requiresNotification: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderStatusUpdateInputDto implements IOrderStatusUpdateInputDto {
    orderLocationDetailId: number;
    orderStatusId: number;
    note: string | undefined;
    notifyPM: boolean;
    notifySalesAgent: boolean;

    constructor(data?: IOrderStatusUpdateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderStatusId = _data['orderStatusId'];
            this.note = _data['note'];
            this.notifyPM = _data['notifyPM'];
            this.notifySalesAgent = _data['notifySalesAgent'];
        }
    }

    static fromJS(data: any): OrderStatusUpdateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusUpdateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderStatusId'] = this.orderStatusId;
        data['note'] = this.note;
        data['notifyPM'] = this.notifyPM;
        data['notifySalesAgent'] = this.notifySalesAgent;
        return data;
    }

    clone(): OrderStatusUpdateInputDto {
        const json = this.toJSON();
        let result = new OrderStatusUpdateInputDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStatusUpdateInputDto {
    orderLocationDetailId: number;
    orderStatusId: number;
    note: string | undefined;
    notifyPM: boolean;
    notifySalesAgent: boolean;
}

export class OrderUserDto implements IOrderUserDto {
    tenantId: number | undefined;
    orderId: number;
    userId: number;
    user: UserListDto;
    id: number;

    constructor(data?: IOrderUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.userId = _data['userId'];
            this.user = _data['user'] ? UserListDto.fromJS(_data['user']) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderUserDto {
        const json = this.toJSON();
        let result = new OrderUserDto();
        result.init(json);
        return result;
    }
}

export interface IOrderUserDto {
    tenantId: number | undefined;
    orderId: number;
    userId: number;
    user: UserListDto;
    id: number;
}

export class OrderUserEditDto implements IOrderUserEditDto {
    tenantId: number | undefined;
    orderId: number;
    userId: number;
    user: UserListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.userId = _data['userId'];
            this.user = _data['user'] ? UserListDto.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderUserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderUserEditDto {
        const json = this.toJSON();
        let result = new OrderUserEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderUserEditDto {
    tenantId: number | undefined;
    orderId: number;
    userId: number;
    user: UserListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderViewDto implements IOrderViewDto {
    tenantId: number | undefined;
    orderNumber: string | undefined;
    customerId: number;
    customer: CustomerEditDto;
    partnerId: number;
    partner: PartnerEditDto;
    orderStage: OrderStage;
    salesAgentId: number;
    salesAgent: UserListDto;
    orderSalesAgents: OrderSalesAgentDto[] | undefined;
    salesEngineerId: number | undefined;
    salesCampaignId: number | undefined;
    salesEngineer: UserListDto;
    createAttribJson: string | undefined;
    quoteId: number | undefined;
    ticketId: number | undefined;
    ticketNumber: string | undefined;
    tickets: TicketNumberDto[] | undefined;
    orderUsers: OrderUserEditDto[] | undefined;
    orderLocations: OrderLocationViewDto[] | undefined;
    internalSalesAgentId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderNumber = _data['orderNumber'];
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnerEditDto.fromJS(_data['partner']) : <any>undefined;
            this.orderStage = _data['orderStage'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? UserListDto.fromJS(_data['salesAgent']) : <any>undefined;
            if (Array.isArray(_data['orderSalesAgents'])) {
                this.orderSalesAgents = [] as any;
                for (let item of _data['orderSalesAgents']) this.orderSalesAgents.push(OrderSalesAgentDto.fromJS(item));
            }
            this.salesEngineerId = _data['salesEngineerId'];
            this.salesCampaignId = _data['salesCampaignId'];
            this.salesEngineer = _data['salesEngineer'] ? UserListDto.fromJS(_data['salesEngineer']) : <any>undefined;
            this.createAttribJson = _data['createAttribJson'];
            this.quoteId = _data['quoteId'];
            this.ticketId = _data['ticketId'];
            this.ticketNumber = _data['ticketNumber'];
            if (Array.isArray(_data['tickets'])) {
                this.tickets = [] as any;
                for (let item of _data['tickets']) this.tickets.push(TicketNumberDto.fromJS(item));
            }
            if (Array.isArray(_data['orderUsers'])) {
                this.orderUsers = [] as any;
                for (let item of _data['orderUsers']) this.orderUsers.push(OrderUserEditDto.fromJS(item));
            }
            if (Array.isArray(_data['orderLocations'])) {
                this.orderLocations = [] as any;
                for (let item of _data['orderLocations']) this.orderLocations.push(OrderLocationViewDto.fromJS(item));
            }
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderNumber'] = this.orderNumber;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['orderStage'] = this.orderStage;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        if (Array.isArray(this.orderSalesAgents)) {
            data['orderSalesAgents'] = [];
            for (let item of this.orderSalesAgents) data['orderSalesAgents'].push(item.toJSON());
        }
        data['salesEngineerId'] = this.salesEngineerId;
        data['salesCampaignId'] = this.salesCampaignId;
        data['salesEngineer'] = this.salesEngineer ? this.salesEngineer.toJSON() : <any>undefined;
        data['createAttribJson'] = this.createAttribJson;
        data['quoteId'] = this.quoteId;
        data['ticketId'] = this.ticketId;
        data['ticketNumber'] = this.ticketNumber;
        if (Array.isArray(this.tickets)) {
            data['tickets'] = [];
            for (let item of this.tickets) data['tickets'].push(item.toJSON());
        }
        if (Array.isArray(this.orderUsers)) {
            data['orderUsers'] = [];
            for (let item of this.orderUsers) data['orderUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocations)) {
            data['orderLocations'] = [];
            for (let item of this.orderLocations) data['orderLocations'].push(item.toJSON());
        }
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderViewDto {
        const json = this.toJSON();
        let result = new OrderViewDto();
        result.init(json);
        return result;
    }
}

export interface IOrderViewDto {
    tenantId: number | undefined;
    orderNumber: string | undefined;
    customerId: number;
    customer: CustomerEditDto;
    partnerId: number;
    partner: PartnerEditDto;
    orderStage: OrderStage;
    salesAgentId: number;
    salesAgent: UserListDto;
    orderSalesAgents: OrderSalesAgentDto[] | undefined;
    salesEngineerId: number | undefined;
    salesCampaignId: number | undefined;
    salesEngineer: UserListDto;
    createAttribJson: string | undefined;
    quoteId: number | undefined;
    ticketId: number | undefined;
    ticketNumber: string | undefined;
    tickets: TicketNumberDto[] | undefined;
    orderUsers: OrderUserEditDto[] | undefined;
    orderLocations: OrderLocationViewDto[] | undefined;
    internalSalesAgentId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrdersAgingDashboardDto implements IOrdersAgingDashboardDto {
    orderStatusId: number;
    orderStatusName: string | undefined;
    two: number;
    four: number;
    ten: number;
    twenty: number;
    thirty: number;
    sixty: number;
    ninety: number;
    oneTwenty: number;
    oneTwentyPlus: number;
    readonly total: number;

    constructor(data?: IOrdersAgingDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatusName = _data['orderStatusName'];
            this.two = _data['two'];
            this.four = _data['four'];
            this.ten = _data['ten'];
            this.twenty = _data['twenty'];
            this.thirty = _data['thirty'];
            this.sixty = _data['sixty'];
            this.ninety = _data['ninety'];
            this.oneTwenty = _data['oneTwenty'];
            this.oneTwentyPlus = _data['oneTwentyPlus'];
            (<any>this).total = _data['total'];
        }
    }

    static fromJS(data: any): OrdersAgingDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersAgingDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatusName'] = this.orderStatusName;
        data['two'] = this.two;
        data['four'] = this.four;
        data['ten'] = this.ten;
        data['twenty'] = this.twenty;
        data['thirty'] = this.thirty;
        data['sixty'] = this.sixty;
        data['ninety'] = this.ninety;
        data['oneTwenty'] = this.oneTwenty;
        data['oneTwentyPlus'] = this.oneTwentyPlus;
        data['total'] = this.total;
        return data;
    }

    clone(): OrdersAgingDashboardDto {
        const json = this.toJSON();
        let result = new OrdersAgingDashboardDto();
        result.init(json);
        return result;
    }
}

export interface IOrdersAgingDashboardDto {
    orderStatusId: number;
    orderStatusName: string | undefined;
    two: number;
    four: number;
    ten: number;
    twenty: number;
    thirty: number;
    sixty: number;
    ninety: number;
    oneTwenty: number;
    oneTwentyPlus: number;
    total: number;
}

export class OrdersSupportUsersDashboardOutput implements IOrdersSupportUsersDashboardOutput {
    user: string | undefined;
    orderCount: number;
    pastDue: number | undefined;
    dueToday: number | undefined;
    withinFourHoursNotifications: number | undefined;
    afterFourHoursNotifications: number | undefined;
    ticketCount: number | undefined;

    constructor(data?: IOrdersSupportUsersDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data['user'];
            this.orderCount = _data['orderCount'];
            this.pastDue = _data['pastDue'];
            this.dueToday = _data['dueToday'];
            this.withinFourHoursNotifications = _data['withinFourHoursNotifications'];
            this.afterFourHoursNotifications = _data['afterFourHoursNotifications'];
            this.ticketCount = _data['ticketCount'];
        }
    }

    static fromJS(data: any): OrdersSupportUsersDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersSupportUsersDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['user'] = this.user;
        data['orderCount'] = this.orderCount;
        data['pastDue'] = this.pastDue;
        data['dueToday'] = this.dueToday;
        data['withinFourHoursNotifications'] = this.withinFourHoursNotifications;
        data['afterFourHoursNotifications'] = this.afterFourHoursNotifications;
        data['ticketCount'] = this.ticketCount;
        return data;
    }

    clone(): OrdersSupportUsersDashboardOutput {
        const json = this.toJSON();
        let result = new OrdersSupportUsersDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IOrdersSupportUsersDashboardOutput {
    user: string | undefined;
    orderCount: number;
    pastDue: number | undefined;
    dueToday: number | undefined;
    withinFourHoursNotifications: number | undefined;
    afterFourHoursNotifications: number | undefined;
    ticketCount: number | undefined;
}

export class OutputReportCommissionDateToOrder implements IOutputReportCommissionDateToOrder {
    orderNumber: string | undefined;
    orderLocationDetailId: number;
    providerId: number;
    providerName: string | undefined;
    billingAccountNumber: string | undefined;
    customer: string | undefined;
    orderMRR: number;
    previousSecondMRR: number | undefined;
    previousMRR: number | undefined;
    provisionedDate: moment.Moment;
    commissionDate: moment.Moment | undefined;

    constructor(data?: IOutputReportCommissionDateToOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data['orderNumber'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.customer = _data['customer'];
            this.orderMRR = _data['orderMRR'];
            this.previousSecondMRR = _data['previousSecondMRR'];
            this.previousMRR = _data['previousMRR'];
            this.provisionedDate = _data['provisionedDate'] ? moment(_data['provisionedDate'].toString()) : <any>undefined;
            this.commissionDate = _data['commissionDate'] ? moment(_data['commissionDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OutputReportCommissionDateToOrder {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportCommissionDateToOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderNumber'] = this.orderNumber;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['customer'] = this.customer;
        data['orderMRR'] = this.orderMRR;
        data['previousSecondMRR'] = this.previousSecondMRR;
        data['previousMRR'] = this.previousMRR;
        data['provisionedDate'] = this.provisionedDate ? this.provisionedDate.toISOString() : <any>undefined;
        data['commissionDate'] = this.commissionDate ? this.commissionDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): OutputReportCommissionDateToOrder {
        const json = this.toJSON();
        let result = new OutputReportCommissionDateToOrder();
        result.init(json);
        return result;
    }
}

export interface IOutputReportCommissionDateToOrder {
    orderNumber: string | undefined;
    orderLocationDetailId: number;
    providerId: number;
    providerName: string | undefined;
    billingAccountNumber: string | undefined;
    customer: string | undefined;
    orderMRR: number;
    previousSecondMRR: number | undefined;
    previousMRR: number | undefined;
    provisionedDate: moment.Moment;
    commissionDate: moment.Moment | undefined;
}

export class OutputReportDetailedOrderTracking implements IOutputReportDetailedOrderTracking {
    orderNumber: string | undefined;
    orderLocationDetailId: number;
    provider: string | undefined;
    microcorpPartnerManager: string | undefined;
    salesAgent: string | undefined;
    microcorpProvisioner: string | undefined;
    customerId: number;
    customerName: string | undefined;
    locationId: number;
    locationName: string | undefined;
    productId: number;
    product: string | undefined;
    status: string | undefined;
    statusAging: number;
    mrc: number;
    contractTerm: string | undefined;
    contractSignedDate: moment.Moment | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    locationAccountNumber: string | undefined;
    corporateOrderNumber: string | undefined;
    providerOrderNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    lecCircuitId: string | undefined;
    carrierCircuitId: string | undefined;
    accessType: string | undefined;
    orderReceived: moment.Moment | undefined;
    sentToCarrier: moment.Moment | undefined;
    focDate: moment.Moment | undefined;
    circuitAcceptanceDate: moment.Moment | undefined;
    testAndTurnUpDate: moment.Moment | undefined;
    orderCompletionDate: moment.Moment | undefined;
    commissionDate: moment.Moment | undefined;
    lastNote: string | undefined;

    constructor(data?: IOutputReportDetailedOrderTracking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data['orderNumber'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.provider = _data['provider'];
            this.microcorpPartnerManager = _data['microcorpPartnerManager'];
            this.salesAgent = _data['salesAgent'];
            this.microcorpProvisioner = _data['microcorpProvisioner'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.locationId = _data['locationId'];
            this.locationName = _data['locationName'];
            this.productId = _data['productId'];
            this.product = _data['product'];
            this.status = _data['status'];
            this.statusAging = _data['statusAging'];
            this.mrc = _data['mrc'];
            this.contractTerm = _data['contractTerm'];
            this.contractSignedDate = _data['contractSignedDate'] ? moment(_data['contractSignedDate'].toString()) : <any>undefined;
            this.contractStartDate = _data['contractStartDate'] ? moment(_data['contractStartDate'].toString()) : <any>undefined;
            this.contractEndDate = _data['contractEndDate'] ? moment(_data['contractEndDate'].toString()) : <any>undefined;
            this.locationAccountNumber = _data['locationAccountNumber'];
            this.corporateOrderNumber = _data['corporateOrderNumber'];
            this.providerOrderNumber = _data['providerOrderNumber'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.lecCircuitId = _data['lecCircuitId'];
            this.carrierCircuitId = _data['carrierCircuitId'];
            this.accessType = _data['accessType'];
            this.orderReceived = _data['orderReceived'] ? moment(_data['orderReceived'].toString()) : <any>undefined;
            this.sentToCarrier = _data['sentToCarrier'] ? moment(_data['sentToCarrier'].toString()) : <any>undefined;
            this.focDate = _data['focDate'] ? moment(_data['focDate'].toString()) : <any>undefined;
            this.circuitAcceptanceDate = _data['circuitAcceptanceDate']
                ? moment(_data['circuitAcceptanceDate'].toString())
                : <any>undefined;
            this.testAndTurnUpDate = _data['testAndTurnUpDate'] ? moment(_data['testAndTurnUpDate'].toString()) : <any>undefined;
            this.orderCompletionDate = _data['orderCompletionDate'] ? moment(_data['orderCompletionDate'].toString()) : <any>undefined;
            this.commissionDate = _data['commissionDate'] ? moment(_data['commissionDate'].toString()) : <any>undefined;
            this.lastNote = _data['lastNote'];
        }
    }

    static fromJS(data: any): OutputReportDetailedOrderTracking {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportDetailedOrderTracking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderNumber'] = this.orderNumber;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['provider'] = this.provider;
        data['microcorpPartnerManager'] = this.microcorpPartnerManager;
        data['salesAgent'] = this.salesAgent;
        data['microcorpProvisioner'] = this.microcorpProvisioner;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['locationId'] = this.locationId;
        data['locationName'] = this.locationName;
        data['productId'] = this.productId;
        data['product'] = this.product;
        data['status'] = this.status;
        data['statusAging'] = this.statusAging;
        data['mrc'] = this.mrc;
        data['contractTerm'] = this.contractTerm;
        data['contractSignedDate'] = this.contractSignedDate ? this.contractSignedDate.toISOString() : <any>undefined;
        data['contractStartDate'] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data['contractEndDate'] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data['locationAccountNumber'] = this.locationAccountNumber;
        data['corporateOrderNumber'] = this.corporateOrderNumber;
        data['providerOrderNumber'] = this.providerOrderNumber;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['lecCircuitId'] = this.lecCircuitId;
        data['carrierCircuitId'] = this.carrierCircuitId;
        data['accessType'] = this.accessType;
        data['orderReceived'] = this.orderReceived ? this.orderReceived.toISOString() : <any>undefined;
        data['sentToCarrier'] = this.sentToCarrier ? this.sentToCarrier.toISOString() : <any>undefined;
        data['focDate'] = this.focDate ? this.focDate.toISOString() : <any>undefined;
        data['circuitAcceptanceDate'] = this.circuitAcceptanceDate ? this.circuitAcceptanceDate.toISOString() : <any>undefined;
        data['testAndTurnUpDate'] = this.testAndTurnUpDate ? this.testAndTurnUpDate.toISOString() : <any>undefined;
        data['orderCompletionDate'] = this.orderCompletionDate ? this.orderCompletionDate.toISOString() : <any>undefined;
        data['commissionDate'] = this.commissionDate ? this.commissionDate.toISOString() : <any>undefined;
        data['lastNote'] = this.lastNote;
        return data;
    }

    clone(): OutputReportDetailedOrderTracking {
        const json = this.toJSON();
        let result = new OutputReportDetailedOrderTracking();
        result.init(json);
        return result;
    }
}

export interface IOutputReportDetailedOrderTracking {
    orderNumber: string | undefined;
    orderLocationDetailId: number;
    provider: string | undefined;
    microcorpPartnerManager: string | undefined;
    salesAgent: string | undefined;
    microcorpProvisioner: string | undefined;
    customerId: number;
    customerName: string | undefined;
    locationId: number;
    locationName: string | undefined;
    productId: number;
    product: string | undefined;
    status: string | undefined;
    statusAging: number;
    mrc: number;
    contractTerm: string | undefined;
    contractSignedDate: moment.Moment | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    locationAccountNumber: string | undefined;
    corporateOrderNumber: string | undefined;
    providerOrderNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    lecCircuitId: string | undefined;
    carrierCircuitId: string | undefined;
    accessType: string | undefined;
    orderReceived: moment.Moment | undefined;
    sentToCarrier: moment.Moment | undefined;
    focDate: moment.Moment | undefined;
    circuitAcceptanceDate: moment.Moment | undefined;
    testAndTurnUpDate: moment.Moment | undefined;
    orderCompletionDate: moment.Moment | undefined;
    commissionDate: moment.Moment | undefined;
    lastNote: string | undefined;
}

export class OutputReportDetailsSales implements IOutputReportDetailsSales {
    partnerId: number;
    partner: string | undefined;
    salesAgentId: number;
    salesAgent: string | undefined;
    spmId: number;
    spm: string | undefined;
    provisioner: string | undefined;
    mrc: number;
    nrc: number;
    customer: string | undefined;
    location: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    productId: number;
    product: string | undefined;
    providerId: number;
    provider: string | undefined;
    orderId: number;
    orderNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    orderStatus: string | undefined;
    orderStatusDate: moment.Moment;
    focDate: moment.Moment | undefined;
    statusDaysOld: number;
    ioId: number | undefined;
    io: string | undefined;

    constructor(data?: IOutputReportDetailsSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'];
            this.spmId = _data['spmId'];
            this.spm = _data['spm'];
            this.provisioner = _data['provisioner'];
            this.mrc = _data['mrc'];
            this.nrc = _data['nrc'];
            this.customer = _data['customer'];
            this.location = _data['location'];
            this.address = _data['address'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.productId = _data['productId'];
            this.product = _data['product'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.orderStatus = _data['orderStatus'];
            this.orderStatusDate = _data['orderStatusDate'] ? moment(_data['orderStatusDate'].toString()) : <any>undefined;
            this.focDate = _data['focDate'] ? moment(_data['focDate'].toString()) : <any>undefined;
            this.statusDaysOld = _data['statusDaysOld'];
            this.ioId = _data['ioId'];
            this.io = _data['io'];
        }
    }

    static fromJS(data: any): OutputReportDetailsSales {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportDetailsSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent;
        data['spmId'] = this.spmId;
        data['spm'] = this.spm;
        data['provisioner'] = this.provisioner;
        data['mrc'] = this.mrc;
        data['nrc'] = this.nrc;
        data['customer'] = this.customer;
        data['location'] = this.location;
        data['address'] = this.address;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['productId'] = this.productId;
        data['product'] = this.product;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['orderStatus'] = this.orderStatus;
        data['orderStatusDate'] = this.orderStatusDate ? this.orderStatusDate.toISOString() : <any>undefined;
        data['focDate'] = this.focDate ? this.focDate.toISOString() : <any>undefined;
        data['statusDaysOld'] = this.statusDaysOld;
        data['ioId'] = this.ioId;
        data['io'] = this.io;
        return data;
    }

    clone(): OutputReportDetailsSales {
        const json = this.toJSON();
        let result = new OutputReportDetailsSales();
        result.init(json);
        return result;
    }
}

export interface IOutputReportDetailsSales {
    partnerId: number;
    partner: string | undefined;
    salesAgentId: number;
    salesAgent: string | undefined;
    spmId: number;
    spm: string | undefined;
    provisioner: string | undefined;
    mrc: number;
    nrc: number;
    customer: string | undefined;
    location: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    productId: number;
    product: string | undefined;
    providerId: number;
    provider: string | undefined;
    orderId: number;
    orderNumber: string | undefined;
    partnerOrderNumber: string | undefined;
    orderStatus: string | undefined;
    orderStatusDate: moment.Moment;
    focDate: moment.Moment | undefined;
    statusDaysOld: number;
    ioId: number | undefined;
    io: string | undefined;
}

export class OutputReportExecSummPartnerSales implements IOutputReportExecSummPartnerSales {
    providerId: number;
    provider: string | undefined;
    sales: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummPartnerSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            if (Array.isArray(_data['sales'])) {
                this.sales = [] as any;
                for (let item of _data['sales']) this.sales.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummPartnerSales {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummPartnerSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        if (Array.isArray(this.sales)) {
            data['sales'] = [];
            for (let item of this.sales) data['sales'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummPartnerSales {
        const json = this.toJSON();
        let result = new OutputReportExecSummPartnerSales();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummPartnerSales {
    providerId: number;
    provider: string | undefined;
    sales: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportExecSummProviderSales implements IOutputReportExecSummProviderSales {
    partnerId: number;
    partner: string | undefined;
    sales: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummProviderSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            if (Array.isArray(_data['sales'])) {
                this.sales = [] as any;
                for (let item of _data['sales']) this.sales.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummProviderSales {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummProviderSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        if (Array.isArray(this.sales)) {
            data['sales'] = [];
            for (let item of this.sales) data['sales'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummProviderSales {
        const json = this.toJSON();
        let result = new OutputReportExecSummProviderSales();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummProviderSales {
    partnerId: number;
    partner: string | undefined;
    sales: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportTrendingSales implements IOutputReportTrendingSales {
    searchType: string | undefined;
    productCategoryName: string | undefined;
    sales: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportTrendingSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchType = _data['searchType'];
            this.productCategoryName = _data['productCategoryName'];
            if (Array.isArray(_data['sales'])) {
                this.sales = [] as any;
                for (let item of _data['sales']) this.sales.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportTrendingSales {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportTrendingSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['searchType'] = this.searchType;
        data['productCategoryName'] = this.productCategoryName;
        if (Array.isArray(this.sales)) {
            data['sales'] = [];
            for (let item of this.sales) data['sales'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportTrendingSales {
        const json = this.toJSON();
        let result = new OutputReportTrendingSales();
        result.init(json);
        return result;
    }
}

export interface IOutputReportTrendingSales {
    searchType: string | undefined;
    productCategoryName: string | undefined;
    sales: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class PartnerCustomerSalesDashboardOutput implements IPartnerCustomerSalesDashboardOutput {
    id: number;
    partner: string | undefined;
    customerId: number;
    customer: string | undefined;
    providerId: number;
    provider: string | undefined;
    product: string | undefined;
    total: number;

    constructor(data?: IPartnerCustomerSalesDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.partner = _data['partner'];
            this.customerId = _data['customerId'];
            this.customer = _data['customer'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            this.product = _data['product'];
            this.total = _data['total'];
        }
    }

    static fromJS(data: any): PartnerCustomerSalesDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCustomerSalesDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['partner'] = this.partner;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        data['product'] = this.product;
        data['total'] = this.total;
        return data;
    }

    clone(): PartnerCustomerSalesDashboardOutput {
        const json = this.toJSON();
        let result = new PartnerCustomerSalesDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IPartnerCustomerSalesDashboardOutput {
    id: number;
    partner: string | undefined;
    customerId: number;
    customer: string | undefined;
    providerId: number;
    provider: string | undefined;
    product: string | undefined;
    total: number;
}

export class PartnerManagementReportOutput implements IPartnerManagementReportOutput {
    spm: string | undefined;
    pm: string | undefined;
    partnerName: string | undefined;
    partnerSince: moment.Moment | undefined;
    partnerPrincipal: string | undefined;
    phoneNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    salesMTD: number | undefined;
    salesQTD: number | undefined;
    salesYTD: number | undefined;
    salesPrior: number | undefined;
    salesTwoPrior: number | undefined;
    lastNoteDate: moment.Moment | undefined;
    quoteCount: number;
    orderCount: number;
    totalSales: number | undefined;

    constructor(data?: IPartnerManagementReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spm = _data['spm'];
            this.pm = _data['pm'];
            this.partnerName = _data['partnerName'];
            this.partnerSince = _data['partnerSince'] ? moment(_data['partnerSince'].toString()) : <any>undefined;
            this.partnerPrincipal = _data['partnerPrincipal'];
            this.phoneNumber = _data['phoneNumber'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            this.salesMTD = _data['salesMTD'];
            this.salesQTD = _data['salesQTD'];
            this.salesYTD = _data['salesYTD'];
            this.salesPrior = _data['salesPrior'];
            this.salesTwoPrior = _data['salesTwoPrior'];
            this.lastNoteDate = _data['lastNoteDate'] ? moment(_data['lastNoteDate'].toString()) : <any>undefined;
            this.quoteCount = _data['quoteCount'];
            this.orderCount = _data['orderCount'];
            this.totalSales = _data['totalSales'];
        }
    }

    static fromJS(data: any): PartnerManagementReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerManagementReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['spm'] = this.spm;
        data['pm'] = this.pm;
        data['partnerName'] = this.partnerName;
        data['partnerSince'] = this.partnerSince ? this.partnerSince.toISOString() : <any>undefined;
        data['partnerPrincipal'] = this.partnerPrincipal;
        data['phoneNumber'] = this.phoneNumber;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        data['salesMTD'] = this.salesMTD;
        data['salesQTD'] = this.salesQTD;
        data['salesYTD'] = this.salesYTD;
        data['salesPrior'] = this.salesPrior;
        data['salesTwoPrior'] = this.salesTwoPrior;
        data['lastNoteDate'] = this.lastNoteDate ? this.lastNoteDate.toISOString() : <any>undefined;
        data['quoteCount'] = this.quoteCount;
        data['orderCount'] = this.orderCount;
        data['totalSales'] = this.totalSales;
        return data;
    }

    clone(): PartnerManagementReportOutput {
        const json = this.toJSON();
        let result = new PartnerManagementReportOutput();
        result.init(json);
        return result;
    }
}

export interface IPartnerManagementReportOutput {
    spm: string | undefined;
    pm: string | undefined;
    partnerName: string | undefined;
    partnerSince: moment.Moment | undefined;
    partnerPrincipal: string | undefined;
    phoneNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    salesMTD: number | undefined;
    salesQTD: number | undefined;
    salesYTD: number | undefined;
    salesPrior: number | undefined;
    salesTwoPrior: number | undefined;
    lastNoteDate: moment.Moment | undefined;
    quoteCount: number;
    orderCount: number;
    totalSales: number | undefined;
}

export class PartnerOrderNumberEditDto implements IPartnerOrderNumberEditDto {
    orderLocationDetailId: number;
    partnerOrderNumber: string | undefined;

    constructor(data?: IPartnerOrderNumberEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
        }
    }

    static fromJS(data: any): PartnerOrderNumberEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerOrderNumberEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        return data;
    }

    clone(): PartnerOrderNumberEditDto {
        const json = this.toJSON();
        let result = new PartnerOrderNumberEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerOrderNumberEditDto {
    orderLocationDetailId: number;
    partnerOrderNumber: string | undefined;
}

export class PartnerSalesDashboardOutput implements IPartnerSalesDashboardOutput {
    id: number;
    name: string | undefined;
    base: number;
    mtdSales: number;
    qtdSales: number;
    ytdSales: number;

    constructor(data?: IPartnerSalesDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.base = _data['base'];
            this.mtdSales = _data['mtdSales'];
            this.qtdSales = _data['qtdSales'];
            this.ytdSales = _data['ytdSales'];
        }
    }

    static fromJS(data: any): PartnerSalesDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSalesDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['base'] = this.base;
        data['mtdSales'] = this.mtdSales;
        data['qtdSales'] = this.qtdSales;
        data['ytdSales'] = this.ytdSales;
        return data;
    }

    clone(): PartnerSalesDashboardOutput {
        const json = this.toJSON();
        let result = new PartnerSalesDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IPartnerSalesDashboardOutput {
    id: number;
    name: string | undefined;
    base: number;
    mtdSales: number;
    qtdSales: number;
    ytdSales: number;
}

export class ProductListForOrderDto implements IProductListForOrderDto {
    productId: number;
    providerList: ProviderDetailsForOrderDto[] | undefined;

    constructor(data?: IProductListForOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            if (Array.isArray(_data['providerList'])) {
                this.providerList = [] as any;
                for (let item of _data['providerList']) this.providerList.push(ProviderDetailsForOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductListForOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListForOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        if (Array.isArray(this.providerList)) {
            data['providerList'] = [];
            for (let item of this.providerList) data['providerList'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductListForOrderDto {
        const json = this.toJSON();
        let result = new ProductListForOrderDto();
        result.init(json);
        return result;
    }
}

export interface IProductListForOrderDto {
    productId: number;
    providerList: ProviderDetailsForOrderDto[] | undefined;
}

export class ProductMilestoneEditDto implements IProductMilestoneEditDto {
    productId: number;
    milestoneId: number;
    milestone: MilestoneEditDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductMilestoneEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            this.milestoneId = _data['milestoneId'];
            this.milestone = _data['milestone'] ? MilestoneEditDto.fromJS(_data['milestone']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductMilestoneEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMilestoneEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        data['milestoneId'] = this.milestoneId;
        data['milestone'] = this.milestone ? this.milestone.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductMilestoneEditDto {
        const json = this.toJSON();
        let result = new ProductMilestoneEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductMilestoneEditDto {
    productId: number;
    milestoneId: number;
    milestone: MilestoneEditDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderDetailsForOrderDto implements IProviderDetailsForOrderDto {
    providerId: number;
    mrr: number;
    nrr: number;

    constructor(data?: IProviderDetailsForOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.mrr = _data['mrr'];
            this.nrr = _data['nrr'];
        }
    }

    static fromJS(data: any): ProviderDetailsForOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDetailsForOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['mrr'] = this.mrr;
        data['nrr'] = this.nrr;
        return data;
    }

    clone(): ProviderDetailsForOrderDto {
        const json = this.toJSON();
        let result = new ProviderDetailsForOrderDto();
        result.init(json);
        return result;
    }
}

export interface IProviderDetailsForOrderDto {
    providerId: number;
    mrr: number;
    nrr: number;
}

export class SalesLast13ByProductDashboardOutput implements ISalesLast13ByProductDashboardOutput {
    description: string | undefined;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;
    id: number;

    constructor(data?: ISalesLast13ByProductDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data['description'];
            this.orderCount = _data['orderCount'];
            this.mrc = _data['mrc'];
            this.nrc = _data['nrc'];
            this.total = _data['total'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): SalesLast13ByProductDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLast13ByProductDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['description'] = this.description;
        data['orderCount'] = this.orderCount;
        data['mrc'] = this.mrc;
        data['nrc'] = this.nrc;
        data['total'] = this.total;
        data['id'] = this.id;
        return data;
    }

    clone(): SalesLast13ByProductDashboardOutput {
        const json = this.toJSON();
        let result = new SalesLast13ByProductDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ISalesLast13ByProductDashboardOutput {
    description: string | undefined;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;
    id: number;
}

export class SalesLast13DashboardOutput implements ISalesLast13DashboardOutput {
    description: string | undefined;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;

    constructor(data?: ISalesLast13DashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data['description'];
            this.orderCount = _data['orderCount'];
            this.mrc = _data['mrc'];
            this.nrc = _data['nrc'];
            this.total = _data['total'];
        }
    }

    static fromJS(data: any): SalesLast13DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLast13DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['description'] = this.description;
        data['orderCount'] = this.orderCount;
        data['mrc'] = this.mrc;
        data['nrc'] = this.nrc;
        data['total'] = this.total;
        return data;
    }

    clone(): SalesLast13DashboardOutput {
        const json = this.toJSON();
        let result = new SalesLast13DashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ISalesLast13DashboardOutput {
    description: string | undefined;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;
}

export class SalesLast18DashboardOutput implements ISalesLast18DashboardOutput {
    description: string | undefined;
    providerId: number;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;

    constructor(data?: ISalesLast18DashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data['description'];
            this.providerId = _data['providerId'];
            this.orderCount = _data['orderCount'];
            this.mrc = _data['mrc'];
            this.nrc = _data['nrc'];
            this.total = _data['total'];
        }
    }

    static fromJS(data: any): SalesLast18DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLast18DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['description'] = this.description;
        data['providerId'] = this.providerId;
        data['orderCount'] = this.orderCount;
        data['mrc'] = this.mrc;
        data['nrc'] = this.nrc;
        data['total'] = this.total;
        return data;
    }

    clone(): SalesLast18DashboardOutput {
        const json = this.toJSON();
        let result = new SalesLast18DashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ISalesLast18DashboardOutput {
    description: string | undefined;
    providerId: number;
    orderCount: number;
    mrc: number;
    nrc: number;
    total: number;
}

export class SendOrderDetailLocationOutput implements ISendOrderDetailLocationOutput {
    orderLocationDetailId: number;
    productName: string | undefined;
    providerName: string | undefined;

    constructor(data?: ISendOrderDetailLocationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.productName = _data['productName'];
            this.providerName = _data['providerName'];
        }
    }

    static fromJS(data: any): SendOrderDetailLocationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SendOrderDetailLocationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['productName'] = this.productName;
        data['providerName'] = this.providerName;
        return data;
    }

    clone(): SendOrderDetailLocationOutput {
        const json = this.toJSON();
        let result = new SendOrderDetailLocationOutput();
        result.init(json);
        return result;
    }
}

export interface ISendOrderDetailLocationOutput {
    orderLocationDetailId: number;
    productName: string | undefined;
    providerName: string | undefined;
}

export class SendOrderDetailsOutput implements ISendOrderDetailsOutput {
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    orderLocationDetailList: SendOrderDetailLocationOutput[] | undefined;

    constructor(data?: ISendOrderDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipCode = _data['zipCode'];
            if (Array.isArray(_data['orderLocationDetailList'])) {
                this.orderLocationDetailList = [] as any;
                for (let item of _data['orderLocationDetailList'])
                    this.orderLocationDetailList.push(SendOrderDetailLocationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendOrderDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SendOrderDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipCode'] = this.zipCode;
        if (Array.isArray(this.orderLocationDetailList)) {
            data['orderLocationDetailList'] = [];
            for (let item of this.orderLocationDetailList) data['orderLocationDetailList'].push(item.toJSON());
        }
        return data;
    }

    clone(): SendOrderDetailsOutput {
        const json = this.toJSON();
        let result = new SendOrderDetailsOutput();
        result.init(json);
        return result;
    }
}

export interface ISendOrderDetailsOutput {
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    orderLocationDetailList: SendOrderDetailLocationOutput[] | undefined;
}
